/* Halsa theme behaviour. No dependencies. Every enhancement degrades to plain HTML
   when JS is off: drawers become real pages, the slider stacks, forms post normally. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion:reduce)');

  function t(key, fallback) {
    var store = window.HalsaStrings || {};
    return store[key] || fallback;
  }

  /* ---------- money ---------- */
  // Shopify's own money_format placeholders. Multiplying a pre-formatted string is
  // wrong, so quantity totals are computed from cents and formatted here.
  // The result is HTML, exactly like Liquid's money filter: a shop's format is
  // often "<span class=money>{{amount}} Lek</span>", so it goes in with
  // innerHTML. Set as text, the tags showed up on the page.
  function formatMoney(cents, format) {
    var fmt = format || window.HalsaMoney || '{{amount}}';
    var value = Number(cents);
    if (isNaN(value)) return '';

    function group(number, decimals, thousands, decimal) {
      number = (number / 100).toFixed(decimals);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
      return decimals && parts[1] ? whole + decimal + parts[1] : whole;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(value, 0, ' ', ',');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(value, 2, ' ', '.');
        default: return group(value, 2, ',', '.');
      }
    });
  }

  /* ---------- status announcements ---------- */
  var liveRegion = null;
  function announce(message) {
    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.className = 'h-visually-hidden';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = message;
  }

  function toast(message, isError) {
    var host = document.querySelector('.h-toasts');
    if (!host) {
      host = document.createElement('div');
      host.className = 'h-toasts';
      document.body.appendChild(host);
    }
    var el = document.createElement('div');
    el.className = 'h-toast' + (isError ? ' h-toast--error' : '');
    el.textContent = message;
    host.appendChild(el);
    setTimeout(function () { el.classList.add('is-out'); }, 3200);
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 3600);
    announce(message);
  }

  /* ---------- ticker pause ---------- */
  function tickers() {
    document.querySelectorAll('[data-h-ticker-toggle]').forEach(function (b) {
      if (b.dataset.hReady) return;
      b.dataset.hReady = '1';
      var track = b.closest('.h-ticker');
      b.addEventListener('click', function () {
        var paused = track.classList.toggle('is-paused');
        b.setAttribute('aria-pressed', paused ? 'true' : 'false');
        b.setAttribute('aria-label', paused ? t('play', 'Play') : t('pause', 'Pause'));
      });
    });
  }

  /* ---------- countdown ---------- */
  var countdownTimer = null;
  function countdowns() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-h-countdown]'));
    if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
    if (!nodes.length) return;
    var DAY = 86400000;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    nodes.forEach(function (el) {
      var stamp = Date.parse(el.getAttribute('data-h-countdown'));
      if (isNaN(stamp)) { el.hidden = true; return; }
      el.dataset.deadline = stamp;
      el.dataset.daily = el.hasAttribute('data-h-countdown-daily') ? '1' : '';
    });

    function tick() {
      var now = Date.now();
      nodes.forEach(function (el) {
        var deadline = parseInt(el.dataset.deadline, 10);
        if (isNaN(deadline)) return;

        if (deadline <= now) {
          if (el.dataset.daily) {
            // A daily flash rolls to the same time tomorrow rather than sitting at zero.
            while (deadline <= now) deadline += DAY;
            el.dataset.deadline = deadline;
          } else {
            el.hidden = true;
            return;
          }
        }

        var left = Math.floor((deadline - now) / 1000);
        // The Big Draw counts in days · hours · minutes, each figure in its own
        // <b data-unit>, beside a translated word the server already wrote.
        if (el.hasAttribute('data-h-countdown-dhm')) {
          var units = { d: Math.floor(left / 86400), h: Math.floor(left / 3600) % 24, m: Math.floor(left / 60) % 60 };
          Object.keys(units).forEach(function (u) {
            var b = el.querySelector('[data-unit="' + u + '"]');
            if (b) b.textContent = units[u];
          });
          el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
          return;
        }
        // Boxed clocks mark their figures, so a box's own label is left alone.
        var parts = el.querySelectorAll('[data-cd]');
        if (!parts.length) parts = el.querySelectorAll('span');
        var h = Math.floor(left / 3600), m = Math.floor(left / 60) % 60, sec = left % 60;
        if (parts[0]) parts[0].textContent = pad(h);
        if (parts[1]) parts[1].textContent = pad(m);
        if (parts[2]) parts[2].textContent = pad(sec);
        el.setAttribute('aria-label', h + 'h ' + m + 'm ' + sec + 's');
      });
    }
    tick();
    countdownTimer = setInterval(tick, 1000);
  }

  /* ---------- tabs (WAI-ARIA tabs pattern) ---------- */
  function tabs() {
    document.querySelectorAll('[data-h-tabs]').forEach(function (list) {
      if (list.dataset.hReady) return;
      list.dataset.hReady = '1';
      var btns = Array.prototype.slice.call(list.querySelectorAll('button[role="tab"]'));
      if (btns.length < 2) return;

      function select(btn, focus) {
        btns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.setAttribute('tabindex', on ? '0' : '-1');
          var panel = document.getElementById(b.getAttribute('data-panel'));
          if (panel) {
            panel.classList.toggle('is-active', on);
            panel.hidden = !on;
          }
        });
        if (focus) btn.focus();
      }

      btns.forEach(function (b) {
        b.addEventListener('click', function () { select(b, false); });
        b.addEventListener('keydown', function (e) {
          var idx = btns.indexOf(b), next = null;
          // A vertical rail is walked with Up/Down; a horizontal strip with Left/Right.
          var vertical = list.getAttribute('aria-orientation') === 'vertical';
          var fwd = vertical ? 'ArrowDown' : 'ArrowRight';
          var back = vertical ? 'ArrowUp' : 'ArrowLeft';
          if (e.key === fwd) next = btns[(idx + 1) % btns.length];
          else if (e.key === back) next = btns[(idx - 1 + btns.length) % btns.length];
          else if (e.key === 'Home') next = btns[0];
          else if (e.key === 'End') next = btns[btns.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  /* ---------- show/hide password (design 5b) ---------- */
  function reveal() {
    document.querySelectorAll('[data-h-reveal]').forEach(function (b) {
      if (b.dataset.hReady) return;
      b.dataset.hReady = '1';
      var field = document.getElementById(b.getAttribute('data-h-reveal'));
      if (!field) return;
      b.setAttribute('aria-controls', field.id);
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        var shown = field.type === 'text';
        field.type = shown ? 'password' : 'text';
        b.setAttribute('aria-pressed', shown ? 'false' : 'true');
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  function quantity() {
    document.querySelectorAll('.h-qty').forEach(function (box) {
      if (box.dataset.hReady) return;
      box.dataset.hReady = '1';
      var input = box.querySelector('input');
      if (!input) return;
      var floor = parseInt(input.getAttribute('min'), 10);
      if (isNaN(floor)) floor = 1;
      box.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
          var v = Math.max(floor, (parseInt(input.value, 10) || floor) + step);
          if (v === parseInt(input.value, 10)) return;
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- points: the same sum as snippets/points.liquid ---------- */
  // Liquid's divided_by on two integers floors, and the snippet never lets the rate
  // drop below 1. Rounding here instead had the product page promise a point the
  // card and the cart then withheld.
  function pointsFor(cents) {
    var rate = Math.max(1, parseInt(window.HalsaPointsRate, 10) || 10);
    return Math.floor(cents / (rate * 100));
  }

  /* ---------- the price box (product page) ---------- */
  // One place decides every figure in the price box, because they have to agree:
  // the headline follows the quantity, so the struck-through price and the saving
  // follow it too — a "was" lower than "now" is what scaling only one of them gave.
  // A chosen subscription plan replaces the one-time price as the unit.
  function quantityTotal() {
    var form = document.getElementById('h-product-form');
    if (!form || form.dataset.hQtyReady) return;
    var input = form.querySelector('input[name="quantity"]');
    var out = document.querySelector('[data-h-qty-total]');
    if (!input || !out) return;
    form.dataset.hQtyReady = '1';

    function cents(el, attr) {
      var raw = el && el.getAttribute(attr);
      return raw ? parseInt(raw, 10) : NaN;
    }

    function render() {
      var qty = Math.max(1, parseInt(input.value, 10) || 1);
      var priceEl = document.querySelector('[data-h-price]');
      var compareEl = document.querySelector('[data-h-compare]');
      var unit = cents(priceEl, 'data-price-raw');
      var compare = cents(compareEl, 'data-compare-raw');
      var plan = form.querySelector('input[name="selling_plan"]:checked');
      if (plan && plan.value) {
        unit = cents(plan, 'data-price-raw');
        compare = cents(plan, 'data-compare-raw');
      }
      if (isNaN(unit)) { out.hidden = true; return; }

      var onSale = !isNaN(compare) && compare > unit;
      var off = onSale ? Math.round((compare - unit) * 100 / compare) : null;
      var total = formatMoney(unit * qty);

      if (priceEl) priceEl.innerHTML = total;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.innerHTML = formatMoney(compare * qty);
      }
      [document.querySelector('[data-h-off]'), document.querySelector('[data-h-gallery-off]')].forEach(function (el) {
        if (!el) return;
        el.hidden = !onSale;
        if (onSale) el.textContent = '-' + off + '%';
      });
      var savedEl = document.querySelector('[data-h-saved]');
      if (savedEl) {
        savedEl.hidden = !onSale;
        if (onSale) savedEl.innerHTML = (savedEl.getAttribute('data-template') || '__V__').replace('__V__', formatMoney((compare - unit) * qty));
      }

      // The sticky bar repeats the headline, so it carries the same figures.
      var bar = document.querySelector('[data-h-stickybuy]');
      if (bar) {
        var sPrice = bar.querySelector('[data-h-sticky-price]');
        var sCompare = bar.querySelector('[data-h-sticky-compare]');
        if (sPrice) sPrice.innerHTML = total;
        if (sCompare) {
          sCompare.hidden = !onSale;
          if (onSale) sCompare.innerHTML = formatMoney(compare * qty);
        }
      }

      if (qty < 2) { out.hidden = true; }
      else {
        var tpl = out.getAttribute('data-template') || '__U__';
        out.innerHTML = tpl.replace('__U__', formatMoney(unit));
        out.hidden = false;
      }

      // Points are earned on what is actually spent, so they scale too.
      var pts = document.querySelector('[data-h-points]');
      if (pts) {
        var tpl2 = pts.getAttribute('data-template') || '+__V__';
        pts.textContent = tpl2.replace('__V__', pointsFor(unit * qty).toLocaleString('en-US'));
      }
    }

    input.addEventListener('change', render);
    input.addEventListener('input', render);
    form.addEventListener('change', function (e) { if (e.target.name === 'selling_plan') render(); });
    document.addEventListener('h:variant', render);
    render();
  }

  /* ---------- product gallery ---------- */
  function gallery() {
    document.querySelectorAll('[data-h-gallery]').forEach(function (main) {
      if (main.dataset.hReady) return;
      main.dataset.hReady = '1';
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-h-thumb]'));
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () { showMedia(b.getAttribute('data-h-thumb')); });
      });
    });
  }
  // A slide that is switched away from goes display:none, which does not stop
  // playback: an uploaded video keeps its audio running and a YouTube embed keeps
  // going behind the image you are now looking at. external_video_tag does not set
  // enablejsapi, so the postMessage pause API is unavailable and reassigning src is
  // the only thing that reliably stops an embed.
  function stopMedia(slide) {
    slide.querySelectorAll('video').forEach(function (v) {
      try { v.pause(); } catch (e) {}
    });
    slide.querySelectorAll('iframe').forEach(function (f) {
      if (f.src) f.src = f.src;
    });
  }

  /* ---------- gallery hover zoom ---------- */
  // Bound only where a pointer can actually hover: a touch device has no hover, and
  // a listener there would fight the tap. The larger srcset candidate is requested on
  // the first hover rather than up front — the gallery image is the LCP element on a
  // product page, so nobody should pay for zoom pixels they never ask for.
  function zoom() {
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    document.querySelectorAll('[data-h-zoom]').forEach(function (box) {
      if (box.dataset.hReady) return;
      box.dataset.hReady = '1';
      var img = box.querySelector('img');
      if (!img) return;
      var scale = parseFloat(getComputedStyle(box).getPropertyValue('--h-zoom')) || 2.2;

      function track(e) {
        var r = box.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
        var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
        img.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
      }

      box.addEventListener('mouseenter', function (e) {
        if (!box.dataset.hSharp) {
          box.dataset.hSharp = '1';
          var w = Math.round(box.getBoundingClientRect().width * scale);
          // Changing sizes makes the browser re-pick from the same srcset, so the
          // crisp copy arrives without a second <img> or a hand-built URL.
          if (w > 0) img.sizes = w + 'px';
        }
        track(e);
        box.classList.add('is-zoomed');
      });
      box.addEventListener('mousemove', track);
      box.addEventListener('mouseleave', function () {
        box.classList.remove('is-zoomed');
        img.style.transformOrigin = '';
      });
    });
  }

  /* ---------- reels ---------- */
  // One reel plays at a time: starting a second would leave two soundtracks running
  // in the same rail. Nothing here likes or counts anything — the figures on a card
  // are typed by the merchant, so there is no state to keep.
  function reels() {
    document.querySelectorAll('[data-h-reel]').forEach(function (media) {
      if (media.dataset.hReady) return;
      media.dataset.hReady = '1';
      var video = media.querySelector('video');
      var play = media.querySelector('[data-h-reel-play]');
      var sound = media.querySelector('[data-h-reel-sound]');
      if (!video) return;
      var auto = media.hasAttribute('data-h-reel-auto') && !reduceMotion.matches;
      // The muted content attribute only seeds the property when the element is
      // parsed. Setting it outright means the first autoplay can never be refused
      // for carrying sound, whatever the engine did with the attribute.
      if (auto && video.defaultMuted) video.muted = true;

      function sync() {
        var on = !video.paused && !video.ended;
        media.classList.toggle('is-playing', on);
        media.classList.toggle('is-muted', !!video.muted);
        if (play) play.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (sound) {
          // The button is "Sound": pressed means you can hear it.
          sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          // It is invisible until the video runs; an invisible stop in the tab
          // order is a dead end for a keyboard user.
          sound.tabIndex = on ? 0 : -1;
          if (on) sound.removeAttribute('aria-hidden'); else sound.setAttribute('aria-hidden', 'true');
        }
      }

      // One soundtrack at a time, but what "yield" means depends on the card. An
      // autoplaying one is ambient — silence it and let it run, or the rail goes dead
      // because a visitor turned sound on somewhere else. One a visitor started by
      // hand was started for its content, so muting it would be pointless: stop it.
      function soloAudio() {
        document.querySelectorAll('[data-h-reel]').forEach(function (card) {
          var other = card.querySelector('video');
          if (!other || other === video || other.muted) return;
          if (card.hasAttribute('data-h-reel-auto')) {
            other.muted = true;
            other.dispatchEvent(new Event('volumechange'));
          } else {
            try { other.pause(); } catch (e) {}
          }
        });
      }

      function start() {
        if (!video.muted) soloAudio();
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* a browser refusing autoplay is not an error */ });
      }

      function toggle() {
        if (video.paused || video.ended) {
          delete media.dataset.hHeld;
          start();
        } else {
          // A visitor's pause outranks the observer, or scrolling would undo it.
          media.dataset.hHeld = '1';
          video.pause();
        }
      }

      if (play) play.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
      if (sound) {
        sound.addEventListener('click', function (e) {
          e.preventDefault();
          video.muted = !video.muted;
          if (!video.muted) {
            soloAudio();
            if (video.paused || video.ended) { delete media.dataset.hHeld; start(); }
          }
          sync();
        });
      }
      media.addEventListener('click', function (e) {
        // the buy strip and the three real buttons are their own controls
        if (e.target.closest('.h-reel__buy') || e.target.closest('[data-h-share]')) return;
        if (e.target.closest('[data-h-reel-play]') || e.target.closest('[data-h-reel-sound]')) return;
        toggle();
      });
      ['play', 'pause', 'ended', 'volumechange'].forEach(function (evt) { video.addEventListener(evt, sync); });

      if (auto && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!media.dataset.hHeld) start();
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: 0.55 }).observe(media);
      }
      sync();
    });

    document.querySelectorAll('[data-h-share]').forEach(function (btn) {
      if (btn.dataset.hReady) return;
      btn.dataset.hReady = '1';
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-share-url');
        if (!url) return;
        var abs = new URL(url, window.location.origin).href;
        var title = btn.getAttribute('data-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: abs }).catch(function () { /* dismissed */ });
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(abs).then(function () {
            toast(btn.getAttribute('data-copied') || abs);
          }, function () {});
        }
      });
    });
  }

  /* ---------- mobile menu extras ---------- */
  // A menu item with sub-links opens its own screen over the list; the back
  // button returns to the list and to the row that opened it. The list behind is
  // inert while a screen is up, so Tab and screen readers stay on the screen.
  // Closing the drawer puts it back on the list for next time. The A-Z chips
  // filter their own list in place, and are only ever rendered for letters that
  // actually occur, so a tap always hits something.
  function menuExtras() {
    var menu = document.getElementById('h-menu-drawer');
    if (menu && !menu.dataset.hReady) {
      menu.dataset.hReady = '1';
      var main = menu.querySelector('[data-h-msub-main]');
      var closeSub = function (panel, instant) {
        panel.classList.remove('is-open');
        if (main) main.inert = false;
        var row = menu.querySelector('[data-h-msub="' + panel.id + '"]');
        if (row) row.setAttribute('aria-expanded', 'false');
        clearTimeout(panel._hHide);
        if (instant) panel.hidden = true;
        else panel._hHide = setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 260);
        return row;
      };
      menu.addEventListener('click', function (e) {
        var row = e.target.closest('[data-h-msub]');
        if (row) {
          var panel = document.getElementById(row.getAttribute('data-h-msub'));
          if (!panel) return;
          clearTimeout(panel._hHide);
          panel.hidden = false;
          void panel.offsetWidth;
          panel.classList.add('is-open');
          row.setAttribute('aria-expanded', 'true');
          if (main) main.inert = true;
          menuTiles(panel);
          var first = panel.querySelector('[data-h-msub-back]');
          if (first) first.focus({ preventScroll: true, focusVisible: e.detail === 0 });
          return;
        }
        var back = e.target.closest('[data-h-msub-back]');
        if (back) {
          var from = closeSub(back.closest('[data-h-msub-panel]'));
          if (from) from.focus({ preventScroll: true, focusVisible: e.detail === 0 });
        }
      });
      new MutationObserver(function () {
        if (!menu.hidden) return;
        menu.querySelectorAll('[data-h-msub-panel]').forEach(function (p) { if (!p.hidden) closeSub(p, true); });
      }).observe(menu, { attributes: true, attributeFilter: ['hidden'] });
    }

    document.querySelectorAll('[data-h-alpha]').forEach(function (box) {
      if (box.dataset.hReady) return;
      box.dataset.hReady = '1';
      var list = box.querySelector('[data-h-alpha-list]');
      var keys = Array.prototype.slice.call(box.querySelectorAll('button[data-letter]'));
      if (!list) return;
      // The markup ships the list open so it still works without JS; the chips
      // take over from here.
      if (keys.length) list.hidden = true;

      keys.forEach(function (key) {
        key.addEventListener('click', function () {
          var on = key.getAttribute('aria-pressed') !== 'true';
          keys.forEach(function (k) { k.setAttribute('aria-pressed', k === key && on ? 'true' : 'false'); });
          list.hidden = !on;
          if (!on) return;
          var want = key.getAttribute('data-letter');
          list.querySelectorAll('li[data-letter]').forEach(function (li) {
            li.hidden = li.getAttribute('data-letter') !== want;
          });
        });
      });
    });
  }

  // A tile for a collection without an image borrows its first product's photo,
  // asked for only when that tile's screen opens, so the menu itself never loads
  // products on every page.
  function menuTiles(panel) {
    panel.querySelectorAll('[data-h-mtile]').forEach(function (pic) {
      if (pic.dataset.hReady) return;
      pic.dataset.hReady = '1';
      var url = pic.getAttribute('data-h-mtile').split('?')[0].replace(/\/$/, '') + '/products.json?limit=1';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var p = data && data.products && data.products[0];
          var src = p && p.images && p.images[0] && p.images[0].src;
          if (!src) return;
          var img = new Image();
          img.alt = '';
          img.decoding = 'async';
          img.width = 44;
          img.height = 44;
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          pic.appendChild(img);
        })
        .catch(function () {});
    });
  }

  // Which of a list's ids belong to the variant whose photo is `id`: the shared
  // ones before the first variant photo, then from its photo to the next one.
  // Null when the list is not grouped by variant or the photo is not a start.
  function variantGroup(ids, starts, id) {
    if (!starts.length || starts.indexOf(String(id)) < 0) return null;
    var startIdx = starts.map(function (s) { return ids.indexOf(s); }).filter(function (i) { return i > -1; }).sort(function (a, b) { return a - b; });
    var at = ids.indexOf(String(id));
    if (at < 0 || !startIdx.length) return null;
    var end = ids.length;
    startIdx.forEach(function (i) { if (i > at && i < end) end = i; });
    return ids.slice(0, startIdx[0]).concat(ids.slice(at, end));
  }
  // "Show only the selected variant's photos": the gallery's slides and thumbs
  // outside the variant's group are hidden, and the counter counts what is left.
  function filterVariantMedia(id) {
    var main = document.querySelector('[data-h-gallery][data-variant-media]');
    if (!main) return;
    var starts = (main.getAttribute('data-variant-media') || '').split(',').filter(Boolean);
    var slides = Array.prototype.slice.call(main.querySelectorAll('.h-gallery__slide[data-h-media]'));
    var ids = slides.map(function (sl) { return sl.getAttribute('data-h-media'); });
    var keep = variantGroup(ids, starts, id);
    slides.forEach(function (sl) { sl.toggleAttribute('data-h-out', !!keep && keep.indexOf(sl.getAttribute('data-h-media')) < 0); });
    document.querySelectorAll('[data-h-thumb]').forEach(function (b) { b.hidden = !!keep && keep.indexOf(b.getAttribute('data-h-thumb')) < 0; });
    var total = document.querySelector('[data-h-gallery-total]');
    if (total) total.textContent = keep ? keep.length : ids.length;
  }

  function showMedia(id) {
    if (!id) return;
    var main = document.querySelector('[data-h-gallery]');
    if (!main) return;
    var target = main.querySelector('[data-h-media="' + id + '"]');
    if (!target) return;
    var slides = Array.prototype.slice.call(main.querySelectorAll('.h-gallery__slide'));
    slides.forEach(function (s) {
      var leaving = s !== target && s.classList.contains('is-active');
      s.classList.toggle('is-active', s === target);
      if (leaving) {
        stopMedia(s);
        // The slide goes display:none under the cursor, so mouseleave never fires
        // and the image would come back still magnified next time it is shown.
        s.querySelectorAll('.is-zoomed').forEach(function (z) {
          z.classList.remove('is-zoomed');
          var i = z.querySelector('img');
          if (i) i.style.transformOrigin = '';
        });
      }
    });
    var counter = document.querySelector('[data-h-gallery-index]');
    var shown = slides.filter(function (s) { return !s.hasAttribute('data-h-out'); });
    if (counter) counter.textContent = shown.indexOf(target) + 1;
    document.querySelectorAll('[data-h-thumb]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-h-thumb') === String(id) ? 'true' : 'false');
    });
  }

  /* ---------- variant picker ---------- */
  function variants() {
    document.querySelectorAll('[data-h-variants]').forEach(function (root) {
      if (root.dataset.hReady) return;
      root.dataset.hReady = '1';

      var dataEl = root.querySelector('[data-h-variant-data]');
      // The picker sits above the price box per design 6a, which puts it outside
      // <form>. closest('form') is null there, so fall back to the product form
      // by id — the same one the noscript select posts to.
      var form = root.closest('form') ||
                 document.getElementById(root.getAttribute('data-h-form') || 'h-product-form');
      if (!dataEl || !form) return;

      var list;
      try { list = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!list || !list.length) return;

      var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-h-option-index]'));
      var idInput = form.querySelector('[data-h-variant-id]');
      // The hidden id ships disabled so the <noscript> select owns the post when
      // there is no JS. We are the JS, so take ownership back.
      if (idInput) idInput.disabled = false;
      var submit = form.querySelector('[data-h-submit]');
      var express = form.querySelector('[data-h-express]');
      var priceEl = document.querySelector('[data-h-price]');
      var compareEl = document.querySelector('[data-h-compare]');
      var lowEl = document.querySelector('[data-h-low-stock]');
      var unavailableEl = document.querySelector('[data-h-unavailable]');
      // 0 is a real setting — "never warn" — so it cannot fall through to a default.
      var lowThreshold = parseInt(root.getAttribute('data-low-stock'), 10);
      if (isNaN(lowThreshold)) lowThreshold = 10;
      var lowTemplate = lowEl ? (lowEl.getAttribute('data-template') || '') : '';
      var addLabel = submit ? submit.getAttribute('data-label-add') : '';
      var soldLabel = submit ? submit.getAttribute('data-label-sold') : '';

      // Values are read per option index, so radio cards and a plain select both work.
      function chosen() {
        var byIndex = [];
        inputs.forEach(function (el) {
          var i = parseInt(el.getAttribute('data-h-option-index'), 10);
          if (el.type === 'radio') { if (el.checked) byIndex[i] = el.value; }
          else byIndex[i] = el.value;
        });
        return byIndex;
      }

      function match() {
        var want = chosen();
        for (var i = 0; i < list.length; i++) {
          var v = list[i];
          if (!v.options || v.options.length !== want.length) continue;
          var same = true;
          for (var k = 0; k < want.length; k++) { if (v.options[k] !== want[k]) { same = false; break; } }
          if (same) return v;
        }
        return null;
      }

      function setHidden(el, hide) { if (el) el.hidden = !!hide; }

      // The routine button adds this product first; it has to be the variant on
      // screen, and an unavailable one must not sink every other step with a 422.
      function routines(v) {
        document.querySelectorAll('[data-h-routine-main]').forEach(function (el) {
          if (v && el.name.slice(-4) === '[id]') el.value = v.id;
          el.disabled = !(v && v.available);
        });
      }

      function apply(v, isInitial) {
        var bar = document.querySelector('[data-h-stickybuy]');
        if (!v) {
          if (idInput) idInput.value = '';
          if (submit) { submit.disabled = true; submit.textContent = t('unavailable', soldLabel || 'Unavailable'); }
          setHidden(express, true);
          setHidden(unavailableEl, false);
          // The sticky buttons submit the same form, so they close with it.
          if (bar) bar.querySelectorAll('[data-h-sticky-add],[data-h-sticky-buy]').forEach(function (b) { b.disabled = true; });
          routines(null);
          return;
        }

        if (idInput) idInput.value = v.id;
        if (submit && addLabel && soldLabel) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? addLabel : soldLabel;
        } else if (submit) {
          submit.disabled = !v.available;
        }
        setHidden(express, !v.available);
        setHidden(unavailableEl, v.available);

        // Raw cents only: quantityTotal() turns them into every figure in the price
        // box on the h:variant event below, so quantity and plan are applied once.
        if (priceEl) priceEl.setAttribute('data-price-raw', v.price_raw);
        if (compareEl) compareEl.setAttribute('data-compare-raw', v.compare_raw == null ? '' : v.compare_raw);

        // Subscription prices belong to the variant, so they move with it.
        form.querySelectorAll('input[name="selling_plan"]').forEach(function (radio) {
          var label = radio.closest('.h-plan');
          var priceOut = label && label.querySelector('[data-h-plan-price]');
          var saveOut = label && label.querySelector('[data-h-plan-save]');
          var a = radio.value ? (v.plans || {})[radio.value] : { price: v.price_raw, compare: null };
          radio.disabled = !a;
          if (label) label.hidden = !a;
          if (!a) { if (radio.checked) radio.checked = false; return; }
          radio.setAttribute('data-price-raw', a.price);
          radio.setAttribute('data-compare-raw', a.compare == null ? '' : a.compare);
          if (priceOut) priceOut.innerHTML = formatMoney(a.price);
          if (saveOut) {
            var saves = a.compare != null && a.compare > a.price;
            saveOut.hidden = !saves;
            if (saves) saveOut.innerHTML = (saveOut.getAttribute('data-template') || '__V__').replace('__V__', formatMoney(a.compare - a.price));
          }
        });
        if (!form.querySelector('input[name="selling_plan"]:checked')) {
          var firstPlan = form.querySelector('input[name="selling_plan"]:not([disabled])');
          if (firstPlan) firstPlan.checked = true;
        }

        var low = lowThreshold > 0 && v.inventory !== null && v.inventory > 0 && v.inventory < lowThreshold;
        setHidden(lowEl, !low);
        if (lowEl && low) lowEl.textContent = lowTemplate.replace('__V__', v.inventory);

        if (v.media_id) { filterVariantMedia(v.media_id); showMedia(v.media_id); }
        routines(v);
        var skuEl = document.querySelector('[data-h-sku]');
        if (skuEl) { skuEl.textContent = v.sku || ''; if (skuEl.parentNode) skuEl.parentNode.hidden = !v.sku; }

        document.dispatchEvent(new CustomEvent('h:variant'));
        // Everything that describes the variant follows the variant.
        var stockLine = document.querySelector('[data-h-stock-line]');
        if (stockLine && v.stock) stockLine.textContent = v.stock;
        var stockDetail = document.querySelector('[data-h-stock-detail]');
        if (stockDetail && v.stock) {
          var tail = stockDetail.getAttribute('data-suffix');
          if (tail === null) {
            tail = stockDetail.textContent.indexOf(' · ') > -1
              ? stockDetail.textContent.slice(stockDetail.textContent.lastIndexOf(' · ')) : '';
            stockDetail.setAttribute('data-suffix', tail);
          }
          stockDetail.textContent = v.stock + tail;
        }
        var pickupEl = document.querySelector('[data-h-pickup-detail]');
        if (pickupEl && v.pickup) pickupEl.textContent = v.pickup;
        var unitEl = document.querySelector('[data-h-unit-price]');
        if (unitEl) {
          unitEl.hidden = !v.unit;
          if (v.unit) unitEl.textContent = v.unit;
        }

        // Keep the sticky bar honest — it shows the variant actually in the form.
        // Its prices come from quantityTotal() with the rest of the price box.
        var sBar = bar;
        if (sBar) {
          var sAdd = sBar.querySelector('[data-h-sticky-add]');
          var sBuy = sBar.querySelector('[data-h-sticky-buy]');
          var sVariant = sBar.querySelector('[data-h-sticky-variant]');
          var sStock = sBar.querySelector('[data-h-sticky-stock]');
          if (sVariant && v.title) sVariant.textContent = v.title;
          if (sStock && v.stock) sStock.textContent = v.stock;
          if (sAdd) sAdd.disabled = !v.available;
          if (sBuy) sBuy.disabled = !v.available;
        }

        // Only rewrite the URL once the shopper actually picks something — landing on
        // a product page should not silently gain a ?variant= parameter.
        if (!isInitial && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      inputs.forEach(function (el) {
        el.addEventListener('change', function () {
          // Mirror the picked value into the legend so the header stays truthful.
          var i = el.getAttribute('data-h-option-index');
          // the legend, and with seven or more values the list's field and its
          // confirm button, all name the current value
          document.querySelectorAll('[data-h-option-current="' + i + '"]').forEach(function (current) { current.textContent = el.value; });
          apply(match(), false);
        });
      });
      apply(match(), true);
    });
  }

  /* ---------- option list, 7+ values (design 2026) ---------- */
  // A field that opens into the list; on phones a bottom sheet with "Konfirmo".
  // The radios inside are the picker's own, so choosing one already applies it:
  // on desktop that also closes the list, on a phone the sheet waits for Konfirmo.
  var oselWired = false;
  function optionLists() {
    if (oselWired) return;
    oselWired = true;
    var phone = window.matchMedia('(max-width:600px)');
    function setOpen(box, open) {
      box.classList.toggle('is-open', open);
      var field = box.querySelector('.h-osel__field');
      if (field) field.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('h-osel-open', open && phone.matches);
      if (open) {
        var on = box.querySelector('input:checked') || box.querySelector('input');
        if (on) on.focus();
      } else if (field) field.focus();
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-h-osel-toggle]');
      var box = t && t.closest('[data-h-osel]');
      if (box) { setOpen(box, !box.classList.contains('is-open')); return; }
      document.querySelectorAll('[data-h-osel].is-open').forEach(function (b) {
        if (!b.contains(e.target)) setOpen(b, false);
      });
    });
    document.addEventListener('change', function (e) {
      var box = e.target.closest && e.target.closest('[data-h-osel]');
      if (box && box.classList.contains('is-open') && !phone.matches) setOpen(box, false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-h-osel].is-open').forEach(function (b) { setOpen(b, false); });
    });
  }

  /* ---------- sticky buy bar + order-by countdown (design 6a) ---------- */
  function stickyBuyBar() {
    var bar = document.querySelector('[data-h-stickybuy]');
    var anchor = document.querySelector('.h-buy');
    if (!bar || !anchor || bar.dataset.hReady) return;
    bar.dataset.hReady = '1';

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var gone = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.hidden = !gone;
        bar.classList.toggle('is-in', gone);
      }, { threshold: 0 }).observe(anchor);
    }

    // The stepper mirrors the real input rather than holding its own count.
    var mainQty = document.querySelector('#h-product-form input[name="quantity"]');
    var readout = bar.querySelector('[data-h-sticky-qty-value]');
    function sync() { if (mainQty && readout) readout.textContent = mainQty.value || '1'; }
    bar.querySelectorAll('[data-h-sticky-qty] button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!mainQty) return;
        var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
        mainQty.value = Math.max(1, (parseInt(mainQty.value, 10) || 1) + step);
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
    });
    if (mainQty) mainQty.addEventListener('change', sync);
    sync();
  }

  function cutoffCountdown() {
    document.querySelectorAll('[data-h-cutoff]').forEach(function (el) {
      if (el.dataset.hReady) return;
      el.dataset.hReady = '1';
      var stamp = el.getAttribute('data-h-cutoff');
      var deadline = Date.parse(stamp);
      var clock = el.querySelector('[data-h-cutoff-clock]');
      var today = el.querySelector('[data-h-cutoff-today]');
      var tomorrow = el.querySelector('[data-h-cutoff-tomorrow]');
      if (isNaN(deadline)) { el.hidden = true; return; }
      // The stamp carries the date the page was rendered — possibly yesterday, from
      // Shopify's cache or a tab left open overnight. Once the shop's midnight after
      // that cutoff has passed, today has its own cutoff, so the deadline moves to it.
      var DAY = 86400000;
      var hm = /T(\d\d):(\d\d)/.exec(stamp);
      var sinceMidnight = hm ? (parseInt(hm[1], 10) * 60 + parseInt(hm[2], 10)) * 60000 : 0;

      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        while (Date.now() >= deadline - sinceMidnight + DAY) deadline += DAY;
        var left = Math.floor((deadline - Date.now()) / 1000);
        var past = left <= 0;
        if (clock) clock.hidden = past;
        if (today) today.hidden = past;
        if (tomorrow) tomorrow.hidden = !past;
        if (past) return;
        var parts = clock ? clock.querySelectorAll('span') : [];
        var h = Math.floor(left / 3600), m = Math.floor(left / 60) % 60, sec = left % 60;
        if (parts[0]) parts[0].textContent = pad(h);
        if (parts[1]) parts[1].textContent = pad(m);
        if (parts[2]) parts[2].textContent = pad(sec);
        if (clock) clock.setAttribute('aria-label', h + 'h ' + m + 'm ' + sec + 's');
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- drawers (cart + mobile menu) ---------- */
  var lastFocus = null;

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var open = document.querySelector('[data-h-drawer].is-open');
    if (!open) return;
    var items = Array.prototype.slice.call(open.querySelectorAll(FOCUSABLE)).filter(function (el) {
      if (el.closest('[inert]')) return false;
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!open.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }

  function setExpanded(id, on) {
    document.querySelectorAll('[aria-controls="' + id + '"][aria-expanded]').forEach(function (b) {
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  // `byPointer`: opened with a tap or click, so the first control gets focus
  // without a ring. Opened from the keyboard, the ring shows as usual.
  function openDrawer(id, byPointer) {
    var d = document.getElementById(id);
    if (!d) return false;
    // A close still finishing its fade would hide the drawer we are opening, and
    // leave the page scroll-locked behind an invisible panel.
    clearTimeout(d._hHide);
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    if (id === 'h-cart-drawer') drawerRecs();
    document.documentElement.classList.add('h-locked');
    setExpanded(id, true);
    var focusable = d.querySelector(FOCUSABLE);
    if (focusable) focusable.focus(byPointer ? { focusVisible: false } : undefined);
    return true;
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    if (!document.querySelector('[data-h-drawer].is-open')) document.documentElement.classList.remove('h-locked');
    setExpanded(d.id, false);
    clearTimeout(d._hHide);
    d._hHide = setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function drawers() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-h-drawer-open]');
      if (open) {
        var id = open.getAttribute('data-h-drawer-open');
        if (document.getElementById(id) && openDrawer(id, e.detail > 0)) e.preventDefault();
        return;
      }
      if (e.target.closest('[data-h-drawer-close]')) closeDrawer(e.target.closest('[data-h-drawer]'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-h-drawer].is-open').forEach(closeDrawer);
        return;
      }
      trapFocus(e);
    });
  }

  /* ---------- cart: one path for the drawer and the cart page ---------- */
  // Every cart change asks for every cart view on the page — the drawer and, on
  // /cart, the page itself — so the two can never show different carts.
  function cartSectionIds() {
    var ids = [];
    if (document.getElementById('h-cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('h-cart-notice')) ids.push('cart-notice');
    var page = document.querySelector('[data-h-cart-section]');
    if (page) ids.push(page.getAttribute('data-h-cart-section'));
    return ids;
  }

  function replaceDrawer(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#h-cart-drawer');
    var live = document.getElementById('h-cart-drawer');
    if (!fresh || !live) return;
    // The control that was pressed is about to be replaced. Note which line and
    // which button it was so focus lands on its successor, not on <body> inside a
    // modal dialog.
    var focused = live.contains(document.activeElement) ? document.activeElement : null;
    var key = focused && focused.getAttribute('data-h-line-qty');
    var role = focused && focused.getAttribute('data-h-role');
    var wasOpen = live.classList.contains('is-open');
    live.innerHTML = fresh.innerHTML;
    if (wasOpen) { live.classList.add('is-open'); drawerRecs(); }
    if (focused) {
      var next = (key && live.querySelector('[data-h-line-qty="' + key + '"][data-h-role="' + role + '"]')) ||
                 live.querySelector('.h-drawer__x') || live.querySelector(FOCUSABLE);
      if (next) next.focus();
    }
  }

  // "Plotëso rutinën": Shopify's related products for the newest item in the
  // cart, rendered with the cart (sections/cart-drawer-recs) so items already in
  // it are left out. Kept per cart content, so re-rendering the drawer after a
  // quantity change does not fetch again. With none, the collection stays.
  var drawerRecsCache = {};
  function drawerRecs() {
    var box = document.querySelector('[data-h-drawer-recs]');
    if (!box) return;
    var pid = box.getAttribute('data-h-drawer-recs');
    var key = box.getAttribute('data-h-drawer-recs-key') || pid;
    if (!pid) return;
    function paint(html) { if (html) box.innerHTML = html; }
    if (key in drawerRecsCache) { paint(drawerRecsCache[key]); return; }
    drawerRecsCache[key] = '';
    fetch('/recommendations/products?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related&section_id=cart-drawer-recs')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var body = tmp.querySelector('[data-h-drecs-body]');
        drawerRecsCache[key] = body ? body.outerHTML : '';
        var live = document.querySelector('[data-h-drawer-recs]');
        if (live && (live.getAttribute('data-h-drawer-recs-key') || live.getAttribute('data-h-drawer-recs')) === key) { box = live; paint(drawerRecsCache[key]); }
      })
      .catch(function () {});
  }

  function replaceCartPage(html) {
    var root = document.querySelector('[data-h-cart-section]');
    if (!html || !root) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-h-cart-section]');
    if (!fresh) return;
    var focusedId = root.contains(document.activeElement) ? document.activeElement.id : '';
    root.innerHTML = fresh.innerHTML;
    if (focusedId && document.getElementById(focusedId)) document.getElementById(focusedId).focus();
  }

  function applyCartSections(sections) {
    sections = sections || {};
    replaceDrawer(sections['cart-drawer']);
    replaceNotice(sections['cart-notice']);
    var page = document.querySelector('[data-h-cart-section]');
    if (page) replaceCartPage(sections[page.getAttribute('data-h-cart-section')]);
    syncHeader();
    quantity();
  }

  // Re-read the cart as it stands, after a change the store refused.
  function refreshCart() {
    var ids = cartSectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch('/cart?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applyCartSections)
      .catch(function () { window.location.reload(); });
  }

  function cartJson(r) {
    return r.json().then(function (j) { if (!r.ok) throw j; return j; });
  }

  // Changes go out one at a time, addressed by line key. Fired together they
  // raced: a stale response could land last, and a removal renumbered the lines
  // under a request still in flight, so it changed the wrong product.
  var cartQueue = Promise.resolve();
  function changeCart(key, qty) {
    function run() {
      return fetch('/cart/change.js?h=theme', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: cartSectionIds().join(',') })
      })
        .then(cartJson)
        .then(function (data) {
          if (!data.sections) { window.location.reload(); return data; }
          applyCartSections(data.sections);
          announce(t('cart_updated', 'Cart updated'));
          return data;
        }, function (err) {
          // A 422 — usually "you can't add more" — is the store's answer, not a
          // network failure. Say it, and put back the quantity it refused.
          if (err && (err.description || err.message)) {
            toast(err.description || err.message, true);
            return refreshCart().then(function () { throw err; });
          }
          window.location.reload();
          throw err;
        });
    }
    var p = cartQueue.then(run, run);
    cartQueue = p.catch(function () {});
    return p;
  }

  function syncHeader() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Apps listening for cart changes hear about the theme's own.
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'theme' } }));
        document.querySelectorAll('[data-h-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        // The bottom bar's badge is a count, so an empty cart should show nothing
        // rather than a zero sitting on the button.
        // A count that changed gives the badge a short bump, so the add registers
        // even when the drawer is not opened.
        document.querySelectorAll('[data-h-cart-badge]').forEach(function (b) {
          var was = b.getAttribute('data-count');
          b.hidden = cart.item_count === 0;
          b.setAttribute('data-count', cart.item_count);
          if (was !== null && was !== String(cart.item_count) && cart.item_count > 0) {
            b.classList.remove('is-bump');
            void b.offsetWidth;
            b.classList.add('is-bump');
          }
        });
        var src = document.querySelector('[data-h-cart-total-source]');
        document.querySelectorAll('[data-h-cart-total]').forEach(function (n) {
          if (src) n.textContent = src.textContent.trim();
          else if (cart.total_price === 0) n.textContent = n.getAttribute('data-zero') || n.textContent;
        });
      })
      .catch(function () {});
  }

  function ajaxAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-h-add]');
      if (!form || !window.fetch) return;
      // Let native checkout submits (dynamic checkout) through untouched.
      var submitter = e.submitter || document.activeElement;
      if (submitter && submitter.name === 'checkout') return;

      // "Buy now" posts return_to=/checkout. Without JS Shopify adds and redirects on
      // its own; with JS we add over AJAX and then send them there ourselves.
      var buyNowTarget = submitter && submitter.name === 'return_to' ? (submitter.value || '/checkout') : null;

      e.preventDefault();
      // The product form is novalidate (its variant id is managed in script), so a
      // required custom field is checked here, inputs outside the form included.
      var invalid = Array.prototype.filter.call(form.elements, function (el) { return el.willValidate && !el.checkValidity(); })[0];
      if (invalid) { invalid.reportValidity(); return; }
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.innerHTML = '&hellip;'; }
      var body = new FormData(form);
      if (!buyNowTarget && submitter && submitter.name) body.append(submitter.name, submitter.value);
      var ids = cartSectionIds();
      if (!buyNowTarget && ids.length) body.append('sections', ids.join(','));

      fetch('/cart/add.js?h=theme', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(cartJson)
        .then(function (data) {
          if (buyNowTarget) { window.location.href = buyNowTarget; return; }
          var qv = form.closest('dialog');
          if (qv && qv.open) qv.close();
          if (data.sections && data.sections['cart-notice']) {
            applyCartSections(data.sections);
            // A set ("items[]") answers with every line it added; those lead the cart.
            openNotice(data.items && data.items.length ? data.items.length : 1);
          } else if (data.sections && data.sections['cart-drawer']) {
            applyCartSections(data.sections);
            openDrawer('h-cart-drawer');
          } else {
            applyCartSections(data.sections);
            toast(t('added', 'Added to cart'));
          }
          announce(t('added', 'Added to cart'));
          if (btn) { btn.innerHTML = '&#10003;'; btn.removeAttribute('aria-busy'); setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1200); }
        })
        .catch(function (err) {
          if (btn) { btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy'); }
          if (err && err.description) toast(err.description, true);
          else form.submit();
        });
    });
  }

  function drawerQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-h-line-qty]');
      if (!b || !window.fetch) return;
      e.preventDefault();
      var panel = document.getElementById('h-cart-drawer');
      if (panel) panel.classList.add('is-busy');
      // Read the line before the re-render removes it, so undo has something to restore.
      var goingToZero = parseInt(b.getAttribute('data-qty'), 10) === 0;
      var undo = null;
      if (goingToZero) {
        var props = null;
        try { props = JSON.parse(b.getAttribute('data-h-undo-props') || 'null'); } catch (err) {}
        undo = {
          id: b.getAttribute('data-h-undo-id'),
          qty: b.getAttribute('data-h-undo-qty'),
          plan: b.getAttribute('data-h-undo-plan'),
          props: props,
          title: b.getAttribute('data-h-undo-title'),
          amount: b.getAttribute('data-h-undo-amount')
        };
      }
      changeCart(b.getAttribute('data-h-line-qty'), parseInt(b.getAttribute('data-qty'), 10))
        .then(function () { if (undo && undo.id) offerUndo(undo); }, function () {})
        .then(function () { if (panel) panel.classList.remove('is-busy'); });
    });
  }

  /* ---------- drawer coupon + undo (design 8a/8c) ---------- */
  function coupon() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-h-coupon]');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('[data-h-coupon-input]');
      var code = (input && input.value || '').trim();
      if (!code) { if (input) input.focus(); return; }
      // Shopify has no API to apply a code to the cart; /discount/CODE does it for
      // real and comes back to the cart, so this field is not decorative.
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });
  }

  var undoTimer = null;
  function offerUndo(line) {
    var host = document.querySelector('.h-toasts');
    if (!host) { host = document.createElement('div'); host.className = 'h-toasts'; document.body.appendChild(host); }
    var el = document.createElement('div');
    el.className = 'h-toast h-toast--undo';
    var text = document.createElement('span');
    text.textContent = t('removed', 'Removed') .replace('{{ title }}', line.title) +
      (line.amount ? ' · ' + t('removed_amount', '').replace('{{ amount }}', line.amount) : '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'h-toast__undo';
    btn.textContent = t('undo', 'UNDO');
    btn.addEventListener('click', function () {
      // Restore the line as it was: a subscription stays a subscription and line
      // properties (engraving, gift notes, app data) come back with it.
      var item = { id: parseInt(line.id, 10), quantity: parseInt(line.qty, 10) };
      if (line.plan) item.selling_plan = parseInt(line.plan, 10);
      if (line.props && Object.keys(line.props).length) item.properties = line.props;
      fetch('/cart/add.js?h=theme', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item], sections: cartSectionIds().join(',') })
      })
        .then(cartJson)
        .then(function (data) {
          applyCartSections(data.sections);
          announce(t('cart_updated', 'Cart updated'));
        })
        .catch(function (err) {
          if (err && err.description) toast(err.description, true);
          else window.location.reload();
        });
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    el.appendChild(text);
    el.appendChild(btn);
    host.appendChild(el);
    clearTimeout(undoTimer);
    undoTimer = setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
    }, 6000);
    announce(text.textContent);
  }

  /* ---------- cart page: update without a full reload ---------- */
  // The listeners go on the root once and are delegated, so a re-render never
  // needs them bound again. Re-binding on every update is what once doubled them
  // each time, until one tap on ✕ removed two lines.
  function cartPage() {
    var root = document.querySelector('[data-h-cart-section]');
    if (!root || !window.fetch) return;
    if (root.dataset.hReady) return;
    root.dataset.hReady = '1';
    var timers = {};

    function push(key, qty) {
      root.classList.add('is-busy');
      changeCart(key, qty).then(null, function () {}).then(function () { root.classList.remove('is-busy'); });
    }

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-h-cart-qty]');
      if (!input) return;
      var key = input.getAttribute('data-h-cart-qty');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () { push(key, qty); }, 320);
    });

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-h-cart-remove]');
      if (!rm) return;
      e.preventDefault();
      var key = rm.getAttribute('data-h-cart-remove');
      clearTimeout(timers[key]);
      push(key, 0);
    });
  }

  /* ---------- predictive search (designs 7a–7d) ---------- */
  var RECENT_KEY = 'halsa:recent';

  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { return []; }   // private mode, blocked storage, corrupt value
  }
  function writeRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  }
  function rememberSearch(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    writeRecent(list);
  }

  function predictive() {
    var input = document.querySelector('[data-h-predictive]');
    var panel = document.querySelector('[data-h-suggest]');
    if (!input || !panel || !window.fetch) return;

    var results = panel.querySelector('[data-h-suggest-results]');
    var idle = panel.querySelector('[data-h-suggest-idle]');
    var recentBox = panel.querySelector('[data-h-recent]');
    var recentList = panel.querySelector('[data-h-recent-list]');
    var form = input.form;
    var scopeVendor = input.getAttribute('data-h-predictive-vendor') || '';
    var timer = null, controller = null, active = -1, lastQuery = '';

    /* ---- 7a: recent searches ---- */
    function renderRecent() {
      if (!recentBox || !recentList) return;
      var list = readRecent();
      recentBox.hidden = list.length === 0;
      recentList.innerHTML = '';
      list.forEach(function (term, i) {
        var row = document.createElement('div');
        row.className = 'h-recent';
        var link = document.createElement('a');
        link.className = 'h-recent__q';
        link.href = '/search?q=' + encodeURIComponent(term);
        link.id = 'h-sg-r' + i;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.setAttribute('tabindex', '-1');
        link.innerHTML = '<svg class="h-recent__i" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
        var label = document.createElement('span');
        label.textContent = term;
        link.appendChild(label);
        var del = document.createElement('button');
        del.type = 'button';
        del.className = 'h-recent__x';
        del.setAttribute('aria-label', t('remove_recent', 'Remove') + ': ' + term);
        del.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="m6 6 12 12M18 6 6 18"/></svg>';
        del.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          writeRecent(readRecent().filter(function (x) { return x !== term; }));
          renderRecent();
        });
        row.appendChild(link);
        row.appendChild(del);
        recentList.appendChild(row);
      });
    }
    var clearAll = panel.querySelector('[data-h-recent-clear]');
    if (clearAll) clearAll.addEventListener('click', function () { writeRecent([]); renderRecent(); });

    /* ---- panel state ---- */
    function options() {
      var scope = (idle && !idle.hidden) ? idle : results;
      return Array.prototype.slice.call(scope.querySelectorAll('[role="option"]'));
    }
    function showIdle() {
      if (idle) idle.hidden = false;
      if (results) results.hidden = true;
      panel.classList.remove('is-results');
    }
    function showResults() {
      if (idle) idle.hidden = true;
      if (results) results.hidden = false;
      panel.classList.add('is-results');
    }
    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('h-suggest-open');
    }
    // A query still waiting on its debounce, or already in flight, would otherwise
    // land after the panel was closed and open it again with stale results.
    function cancel() {
      clearTimeout(timer);
      if (controller) { controller.abort(); controller = null; }
      panel.classList.remove('is-loading');
    }
    function hide() {
      cancel();
      lastQuery = '';
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      document.documentElement.classList.remove('h-suggest-open');
      active = -1;
    }
    function highlight(index) {
      var items = options();
      items.forEach(function (el) { el.classList.remove('is-active'); el.setAttribute('aria-selected', 'false'); });
      if (!items.length || index < 0) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
      active = (index + items.length) % items.length;
      var el = items[active];
      el.classList.add('is-active');
      el.setAttribute('aria-selected', 'true');
      if (el.id) input.setAttribute('aria-activedescendant', el.id);
      else input.removeAttribute('aria-activedescendant');
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    // The last queries' panels, so deleting or retyping a letter shows them at once.
    var cache = {}, cacheKeys = [];
    function remember(key, val) {
      if (!(key in cache)) { cacheKeys.push(key); if (cacheKeys.length > 30) delete cache[cacheKeys.shift()]; }
      cache[key] = val;
    }
    // The words typed, marked in the product names (accents ignored: "fytyre" marks "fytyrë").
    function fold(x) { return x.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    function markTerms(query) {
      var words = fold(query).split(/\s+/).filter(function (w) { return w.length > 1; });
      if (!words.length) return;
      results.querySelectorAll('.h-sprod__n').forEach(function (el) {
        var text = el.textContent, folded = fold(text), out = '', i = 0;
        // folding keeps one character per character, so positions line up
        if (folded.length !== text.length) return;
        while (i < text.length) {
          var hit = 0;
          for (var k = 0; k < words.length; k++) {
            if (folded.substr(i, words[k].length) === words[k] && (i === 0 || /[^a-z0-9]/.test(folded.charAt(i - 1)))) { hit = Math.max(hit, words[k].length); }
          }
          if (hit) { var span = document.createElement('mark'); span.textContent = text.substr(i, hit); out += span.outerHTML; i += hit; }
          else { var c = document.createElement('span'); c.textContent = text.charAt(i); out += c.innerHTML; i++; }
        }
        el.innerHTML = out;
      });
    }
    // The full product total, from templates/search.count (the predictive API stops at 10).
    function paintTotal(n) {
      if (n == null || isNaN(n)) return;
      // Shopify stops counting at 1000.
      var shown = n >= 1000 ? '1000+' : String(n);
      var total = results.querySelector('[data-h-suggest-total]');
      if (total) total.textContent = (total.getAttribute('data-template') || '__N__').replace('__N__', shown);
      var cta = results.querySelector('[data-h-suggest-cta]');
      var ctaText = cta && (cta.querySelector('[data-h-suggest-cta-text]') || cta);
      if (cta && n > 0) ctaText.textContent = (cta.getAttribute('data-template') || '').replace('__N__', shown);
    }
    function paint(html, query, n) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-h-suggest-body]');
      results.innerHTML = inner ? inner.innerHTML : '';
      markTerms(query);
      paintTotal(n);
      panel.classList.remove('is-loading');
      showResults();
      highlight(-1);
      open();
      var note = results.querySelector('[data-h-suggest-count]');
      if (note) announce(note.textContent.trim());
    }

    function run(query) {
      if (controller) controller.abort();
      var term = scopeVendor ? scopeVendor + ' ' + query : query;
      var key = term.toLowerCase();
      if (cache[key]) { var c = cache[key]; paint(c.html, query, c.n); return; }
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var signal = controller ? { signal: controller.signal } : undefined;
      panel.classList.add('is-loading');
      // Sold-out products last; SKU, barcode and tags searched as well as the title.
      var url = '/search/suggest?q=' + encodeURIComponent(term) +
        '&resources[type]=' + (scopeVendor ? 'product' : 'product,collection,query,article') +
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku,variants.barcode' +
        '&section_id=predictive-results';
      var countUrl = '/search?view=count&type=product&options[prefix]=last&q=' + encodeURIComponent(term);
      var countP = fetch(countUrl, signal).then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { var n = parseInt(t, 10); return isNaN(n) ? null : n; }).catch(function () { return null; });
      var htmlP = fetch(url, signal).then(function (r) { return r.text(); });
      htmlP
        .then(function (html) {
          paint(html, query, null);
          countP.then(function (n) {
            remember(key, { html: html, n: n });
            if (lastQuery === query) paintTotal(n);
          });
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          panel.classList.remove('is-loading');
          hide();
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(timer);
      if (query.length < 2) { cancel(); lastQuery = ''; renderRecent(); showIdle(); open(); highlight(-1); return; }
      if (query === lastQuery) { showResults(); open(); return; }
      lastQuery = query;
      timer = setTimeout(function () { run(query); }, 220);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML.trim()) { showResults(); open(); }
      else { renderRecent(); showIdle(); open(); }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); return; }
      if (panel.hidden) { if (e.key === 'ArrowDown') { renderRecent(); showIdle(); open(); } return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Home' && active > -1) { e.preventDefault(); highlight(0); }
      else if (e.key === 'End' && active > -1) { e.preventDefault(); highlight(options().length - 1); }
      else if (e.key === 'Enter') {
        var items = options();
        if (active > -1 && items[active]) { e.preventDefault(); items[active].click(); }
        else rememberSearch(input.value);
      }
      else if (e.key === 'Tab') { hide(); }
    });

    panel.addEventListener('mousemove', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (!opt) return;
      var idx = options().indexOf(opt);
      if (idx > -1 && idx !== active) highlight(idx);
    });

    // The back and clear buttons live in the search row, not the panel, because on
    // phones the row becomes the panel header. Delegate from the document so their
    // position never matters.
    document.addEventListener('click', function (e) {
      // Phones hide the field behind a search icon. The class has to be on before
      // focus: the field is display:none until it is, and cannot take focus.
      if (e.target.closest('[data-h-search-open]')) {
        e.preventDefault();
        document.documentElement.classList.add('h-suggest-open');
        input.focus();
        return;
      }
      if (e.target.closest('[data-h-suggest-close]')) { hide(); input.blur(); return; }
      if (e.target.closest('[data-h-suggest-clear]')) {
        e.preventDefault();
        input.value = ''; lastQuery = ''; renderRecent(); showIdle(); open(); input.focus(); return;
      }
      if (e.target.closest('a[role="option"]')) rememberSearch(input.value);
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      // The phone search icon sits outside .h-search; the same click that opened the
      // panel reaches here next and must not count as a click outside it.
      if (e.target.closest('[data-h-search-open]')) return;
      if (!panel.contains(e.target) && e.target !== input && !e.target.closest('.h-search')) hide();
    });

    if (form) form.addEventListener('submit', function () { rememberSearch(input.value); hide(); });

    renderRecent();
  }

  /* ---------- sticky compact header ---------- */
  function stickyHeader() {
    var header = document.querySelector('.h-header');
    if (!header || header.dataset.hReady) return;
    header.dataset.hReady = '1';

    // Shopify wraps every section in its own div, so position:sticky has to go on
    // that wrapper — on .h-header itself it would have no room to travel.
    var wrapper = header.closest('[id^="shopify-section"]') || header.parentNode;
    wrapper.classList.add('h-header-sticky');

    if (!('IntersectionObserver' in window)) return;
    var mark = document.createElement('div');
    mark.className = 'h-sticky-mark';
    // Before the wrapper, not inside it: a marker inside a sticky element never leaves the viewport.
    wrapper.parentNode.insertBefore(mark, wrapper);
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle('h-sticky', !entries[0].isIntersecting);
    }, { rootMargin: '0px' }).observe(mark);
  }

  /* ---------- lazy product recommendations ---------- */
  function recommendations() {
    document.querySelectorAll('[data-h-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || !window.fetch || el.dataset.hReady) return;
      el.dataset.hReady = '1';
      var load = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-h-recs]');
          if (!fresh) return;
          el.innerHTML = fresh.innerHTML;
          // This markup arrived after init, so anything inside it still needs wiring.
          carousels();
          quantity();
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '400px' });
        io.observe(el);
      } else load();
    });
  }

  /* ---------- collection carousel ---------- */
  function carousels() {
    document.querySelectorAll('[data-h-carousel]').forEach(function (wrap) {
      if (wrap.dataset.hReady) return;
      wrap.dataset.hReady = '1';
      var track = wrap.querySelector('[data-h-carousel-track]');
      var prev = wrap.querySelector('[data-h-carousel-prev]');
      var next = wrap.querySelector('[data-h-carousel-next]');
      if (!track) return;

      function overflowing() { return track.scrollWidth - track.clientWidth > 4; }

      // The rail's own numbers, measured rather than assumed: the progress thumb is
      // sized by how much of the track is on screen, and the "N of M" count is the
      // column count that actually fits at this width, not the desktop setting.
      function report() {
        var span = track.scrollWidth || 1;
        var seen = Math.min(1, track.clientWidth / span);
        var at = span > track.clientWidth ? track.scrollLeft / span : 0;
        wrap.style.setProperty('--h-thumb-width', (seen * 100).toFixed(2) + '%');
        wrap.style.setProperty('--h-thumb-left', (at * 100).toFixed(2) + '%');
        var out = document.querySelector('[data-h-carousel-visible]');
        if (out) {
          var card = track.firstElementChild;
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 14;
          var step = card ? card.getBoundingClientRect().width + gap : 0;
          var cols = step > 0 ? Math.round(track.clientWidth / step) : 0;
          if (cols > 0) out.textContent = Math.min(cols, track.children.length);
        }
      }

      function update() {
        var can = overflowing();
        [prev, next].forEach(function (b) { if (b) b.hidden = !can; });
        report();
        if (!can) return;
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      function page(dir) {
        // Scroll by whole columns so cards never end up half-cut.
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 14;
        var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        var cols = Math.max(1, Math.floor(track.clientWidth / step));
        track.scrollBy({ left: dir * step * cols, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  }

  /* ---------- collection facets: filter without a full reload ---------- */
  var facetRender = null;
  function facets() {
    // The sidebar is optional — the brand template hides it and filters through the
    // category chips instead, so everything here has to work with no form at all.
    var results = document.querySelector('[data-h-collection-results]');
    if (!results || !window.fetch) return;
    if (results.dataset.hReady) return;
    results.dataset.hReady = '1';
    var form = document.querySelector('[data-h-facet-form]');
    var sectionId = results.getAttribute('data-h-collection-results') ||
                    (form && form.getAttribute('data-h-facet-form'));
    if (!sectionId) return;
    var controller = null;

    // The brand chips live in the brand section, not this one, so a section_id
    // fetch never carried them back. Ask for both sections by name.
    function chipsSectionId() {
      var chips = document.querySelector('[data-h-chips]');
      var host = chips && chips.closest('[id^="shopify-section-"]');
      return host ? host.id.replace('shopify-section-', '') : null;
    }

    function render(url, pushHistory) {
      // Only the newest request may paint. An older one arriving late used to
      // put back the grid, the ticks and the URL of a filter already replaced.
      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var chipsId = chipsSectionId();
      var ids = [sectionId];
      if (chipsId && chipsId !== sectionId) ids.push(chipsId);
      results.classList.add('is-busy');
      fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + ids.join(','),
            controller ? { signal: controller.signal } : undefined)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (sections) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections[sectionId] || '';
          var freshResults = tmp.querySelector('[data-h-collection-results]');
          var freshForm = tmp.querySelector('[data-h-facet-form]');
          var chipsTmp = document.createElement('div');
          chipsTmp.innerHTML = chipsId ? (sections[chipsId] || '') : '';
          var freshChips = chipsTmp.querySelector('[data-h-chips]');

          // Swapping the markup destroys the control that was used. Remember it so
          // a keyboard user stays where they were instead of back at the page top.
          var active = document.activeElement;
          var activeId = active && active.id;
          var activeHref = active && active.tagName === 'A' ? active.getAttribute('data-h-key') : null;
          var swapped = false;

          if (freshResults) { results.innerHTML = freshResults.innerHTML; swapped = true; }
          if (form && freshForm) {
            var open = form.classList.contains('is-open');
            form.innerHTML = freshForm.innerHTML;
            if (open) form.classList.add('is-open');
          }
          var chips = document.querySelector('[data-h-chips]');
          if (chips && freshChips) chips.innerHTML = freshChips.innerHTML;
          // Anything else that depends on the filters (the sub-category chips above
          // the grid) is marked data-h-swap and comes back in the same section.
          tmp.querySelectorAll('[data-h-swap]').forEach(function (fresh) {
            var live = document.querySelector('[data-h-swap="' + fresh.getAttribute('data-h-swap') + '"]');
            if (live) live.innerHTML = fresh.innerHTML;
          });
          applyView();
          facetExtras();
          results.classList.remove('is-busy');
          if (pushHistory && window.history.pushState) window.history.pushState({ h: url }, '', url);
          var counter = document.querySelector('[data-h-result-count]');
          if (counter) announce(counter.textContent.trim());

          var target = (activeId && document.getElementById(activeId)) ||
                       (activeHref && document.querySelector('[data-h-key="' + activeHref + '"]'));
          if (target) target.focus({ preventScroll: true });
          else if (swapped && (!document.activeElement || document.activeElement === document.body)) {
            results.setAttribute('tabindex', '-1');
            results.focus({ preventScroll: true });
          }
          results.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          carousels();
          quantity();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          window.location.href = url;
        });
    }
    facetRender = render;

    function fromForm() {
      var params = new URLSearchParams(new FormData(form));
      var clean = new URLSearchParams();
      params.forEach(function (value, key) { if (value !== '') clean.append(key, value); });
      var qs = clean.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    if (form) {
      form.addEventListener('change', function (e) {
        // The brand search box and the price slider are not filters themselves:
        // the box narrows a list, the slider writes the number boxes, which then
        // report their own change.
        if (e.target.closest('[data-h-facet-search],[data-h-range-thumb]')) return;
        render(fromForm(), true);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); render(fromForm(), true); });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-h-facet-link]');
      if (link) { e.preventDefault(); render(link.getAttribute('href'), true); return; }
      var page = e.target.closest('[data-h-collection-results] .h-pagination a');
      if (page) { e.preventDefault(); render(page.getAttribute('href'), true); }
    });

    // "Shfaq më shumë": the next page's cards are appended to this grid, and its
    // progress block replaces this one. Without JS the link is the next page.
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-h-load-more]');
      if (!more || !results.contains(more)) return;
      e.preventDefault();
      more.setAttribute('aria-busy', 'true');
      var href = more.getAttribute('href');
      fetch(href + (href.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var grid = results.querySelector('[data-h-grid]');
          var freshGrid = tmp.querySelector('[data-h-grid]');
          var first = null;
          if (grid && freshGrid) {
            Array.prototype.slice.call(freshGrid.children).forEach(function (card) {
              if (card.classList.contains('h-colpromo')) return;
              grid.appendChild(card);
              if (!first) first = card;
            });
          }
          var block = results.querySelector('[data-h-loadmore]');
          var freshBlock = tmp.querySelector('[data-h-loadmore]');
          if (block && freshBlock) {
            var prev = freshBlock.querySelector('.h-loadmore__prev');
            if (prev) prev.parentNode.removeChild(prev);
            block.innerHTML = freshBlock.innerHTML;
          } else if (block) block.parentNode.removeChild(block);
          quantity();
          var note = results.querySelector('[data-h-loadmore] p');
          if (note) announce(note.textContent.trim());
          // Keyboard users carry on from the first new card, not from the top.
          var link = first && first.querySelector('a[href]');
          if (link) link.focus({ preventScroll: true });
        })
        .catch(function () { window.location.href = href; });
    });

    window.addEventListener('popstate', function () { render(window.location.href, false); });
  }

  /* ---------- grid / list view (collection toolbar) ---------- */
  var VIEW_KEY = 'halsa:view';
  // The toggle sits in the toolbar, outside the results it switches, so both are
  // found from the document rather than from each other.
  function applyView() {
    var results = document.querySelector('[data-h-collection-results]');
    if (!results) return;
    var view = 'grid';
    try { view = localStorage.getItem(VIEW_KEY) || 'grid'; } catch (e) {}
    results.classList.toggle('is-list', view === 'list');
    document.querySelectorAll('[data-h-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-h-view') === view ? 'true' : 'false');
    });
  }

  /* ---------- filter sidebar extras: brand search, fold, price slider ---------- */
  // Re-run after every AJAX render, since the form is rebuilt each time.
  function facetExtras() {
    document.querySelectorAll('[data-h-range]').forEach(function (range) {
      if (range.dataset.hReady) return;
      range.dataset.hReady = '1';
      var lo = range.querySelector('[data-h-range-thumb="min"]');
      var hi = range.querySelector('[data-h-range-thumb="max"]');
      var boxLo = range.querySelector('input[type="number"][name$="gte"]');
      var boxHi = range.querySelector('input[type="number"][name$="lte"]');
      if (!lo || !hi || !boxLo || !boxHi) return;
      function paint() {
        var max = parseFloat(hi.max) || 1;
        range.style.setProperty('--h-range-lo', (parseFloat(lo.value) / max * 100) + '%');
        range.style.setProperty('--h-range-hi', (parseFloat(hi.value) / max * 100) + '%');
      }
      function slide(e) {
        // the two thumbs may meet but never cross
        if (parseFloat(lo.value) > parseFloat(hi.value)) {
          if (e.target === lo) lo.value = hi.value; else hi.value = lo.value;
        }
        boxLo.value = parseFloat(lo.value) > 0 ? lo.value : '';
        boxHi.value = parseFloat(hi.value) < parseFloat(hi.max) ? hi.value : '';
        paint();
      }
      [lo, hi].forEach(function (thumb) {
        thumb.addEventListener('input', slide);
        // the filter applies once the thumb is let go, not on every pixel
        thumb.addEventListener('change', function () { boxLo.dispatchEvent(new Event('change', { bubbles: true })); });
      });
      paint();
    });
  }

  function facetDelegates() {
    document.addEventListener('input', function (e) {
      var box = e.target.closest && e.target.closest('[data-h-facet-search]');
      if (!box) return;
      var q = box.value.trim().toLowerCase();
      var group = box.closest('.h-facet');
      var list = group && group.querySelector('.h-facet__list');
      if (!list) return;
      list.classList.toggle('is-searching', q !== '');
      list.querySelectorAll('[data-h-facet-value]').forEach(function (li) {
        li.hidden = q !== '' && li.getAttribute('data-h-facet-value').indexOf(q) === -1;
      });
    });
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-h-facet-more]');
      if (more) {
        var list = more.closest('.h-facet').querySelector('.h-facet__list, .h-tagfold');
        if (list) list.classList.remove('is-folded');
        more.hidden = true;
        return;
      }
      var view = e.target.closest('[data-h-view]');
      if (view) {
        try { localStorage.setItem(VIEW_KEY, view.getAttribute('data-h-view')); } catch (err) {}
        applyView();
        return;
      }
      var read = e.target.closest('[data-h-readmore]');
      if (read) {
        var body = document.getElementById(read.getAttribute('data-h-readmore'));
        if (!body) return;
        var open = body.classList.toggle('is-open');
        read.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!read.dataset.more) read.dataset.more = read.textContent;
        read.textContent = open ? (read.getAttribute('data-less') || read.dataset.more) : read.dataset.more;
      }
    });
  }

  // "Lexo më shumë" only appears when the text is actually cut off.
  function readMore() {
    document.querySelectorAll('[data-h-readmore]').forEach(function (b) {
      var body = document.getElementById(b.getAttribute('data-h-readmore'));
      if (body && body.scrollHeight > body.clientHeight + 2) b.hidden = false;
    });
  }

  // Delegated: the "Filtro" button lives in the toolbar, which every filter
  // change re-renders. On phones the open panel covers the page, so the page
  // behind it stops scrolling until it closes.
  var facetToggleWired = false;
  function facetToggle() {
    if (facetToggleWired) return;
    facetToggleWired = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-h-facet-toggle]');
      if (!b) return;
      var panel = document.getElementById(b.getAttribute('data-h-facet-toggle'));
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      document.documentElement.classList.toggle('h-filters-open', open);
      document.querySelectorAll('[data-h-facet-toggle="' + panel.id + '"][aria-expanded]').forEach(function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (open) { var first = panel.querySelector(FOCUSABLE); if (first) first.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var panel = document.querySelector('[data-h-facet-form].is-open');
      if (!panel) return;
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('h-filters-open');
    });
  }

  // Delegated from the document: the select is re-rendered with the results on
  // every filter change, and a listener bound to the old one went with it.
  var sortWired = false;
  function sortSelect() {
    if (sortWired) return;
    sortWired = true;
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-h-sort]');
      if (!sel) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      var next = url.pathname + url.search;
      if (facetRender) facetRender(next, true);
      else window.location.href = next;
    });
  }

  /* ---------- forms that used to rely on inline onchange ---------- */
  function autoSubmit() {
    document.querySelectorAll('[data-h-auto-submit]').forEach(function (el) {
      if (el.dataset.hReady) return;
      el.dataset.hReady = '1';
      el.addEventListener('change', function () {
        var form = el.form || el.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------- recently viewed ("Pe së fundi") ---------- */
  // Product pages note their handle in this browser only; the shelf turns the list
  // back into the theme's own cards, one Section Rendering API call per product,
  // so price and stock are today's. Nothing leaves the device.
  var VIEWED_KEY = 'halsa:viewed';
  function readViewed() {
    try {
      var list = JSON.parse(localStorage.getItem(VIEWED_KEY));
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function writeViewed(list) {
    try { localStorage.setItem(VIEWED_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  function currentProduct() {
    var el = document.querySelector('[data-h-viewed-product]');
    return el ? el.getAttribute('data-h-viewed-product') : '';
  }
  function recordViewed() {
    var handle = currentProduct();
    if (!handle || recordViewed.done) return;
    recordViewed.done = true;
    var list = readViewed().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeViewed(list);
  }

  function viewedShelf() {
    document.querySelectorAll('[data-h-viewed-shelf]').forEach(function (box) {
      if (box.dataset.hReady || !window.fetch) return;
      box.dataset.hReady = '1';
      var track = box.querySelector('[data-h-viewed-track]');
      if (!track) return;
      var limit = parseInt(box.getAttribute('data-limit'), 10) || 8;
      var here = currentProduct();
      var handles = readViewed().filter(function (h) { return h !== here; }).slice(0, limit);
      if (!handles.length) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var GONE = {};

      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=product-card-render')
          // A 404 means the product was deleted or unpublished: forget it. A network
          // failure says nothing about the product, so it is only skipped this time.
          .then(function (r) { return r.ok ? r.text() : (r.status === 404 ? GONE : null); })
          .catch(function () { return null; });
      })).then(function (pages) {
        var gone = [];
        pages.forEach(function (html, i) {
          if (html === GONE) { gone.push(handles[i]); return; }
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var card = tmp.querySelector('.h-pcard');
          if (card) track.appendChild(card);
        });
        if (gone.length) writeViewed(readViewed().filter(function (h) { return gone.indexOf(h) === -1; }));
        if (!track.children.length) return;
        box.hidden = false;
        // Wired only now: an empty track would have measured as nothing to scroll.
        var wrap = track.closest('.h-carousel-wrap');
        if (wrap) wrap.setAttribute('data-h-carousel', '');
        carousels();
        quantity();
      });

      var clear = box.querySelector('[data-h-viewed-clear]');
      if (clear) clear.addEventListener('click', function () {
        writeViewed([]);
        box.hidden = true;
        track.innerHTML = '';
      });
    });
  }

  /* ---------- "Ke parasysh:" on the search page ---------- */
  // Shopify's own query suggestions for what was typed. Liquid has no spelling
  // suggestions, so this is the only real source; with none, nothing shows.
  function didYouMean() {
    document.querySelectorAll('[data-h-didyoumean]').forEach(function (box) {
      if (box.dataset.hReady || !window.fetch) return;
      box.dataset.hReady = '1';
      var q = box.getAttribute('data-h-didyoumean');
      if (!q) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query&resources[limit]=4', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var list = data && data.resources && data.resources.results && data.resources.results.queries || [];
          list = list.filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 3);
          if (!list.length) return;
          list.forEach(function (s, i) {
            if (i) box.appendChild(document.createTextNode(' · '));
            var a = document.createElement('a');
            a.href = root + 'search?q=' + encodeURIComponent(s.text);
            a.textContent = s.text;
            box.appendChild(a);
          });
          box.hidden = false;
        })
        .catch(function () {});
    });
  }

  /* ---------- promo slider (homepage, design 2026) ---------- */
  // A scroll-snap track that swipes on its own; this only keeps the dots, the
  // "1 / 5" counter and the arrows in step with it. It never advances by itself.
  function promoSliders() {
    document.querySelectorAll('[data-h-slider]').forEach(function (box) {
      if (box.dataset.hReady) return;
      box.dataset.hReady = '1';
      var track = box.querySelector('[data-h-slider-track]');
      if (!track) return;
      var slides = track.children;
      var dots = box.querySelectorAll('[data-h-slider-dot]');
      var count = box.querySelector('[data-h-slider-count]');
      function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function go(i) {
        var n = slides.length;
        i = (i + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      function paint() {
        var i = index();
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        Array.prototype.forEach.call(slides, function (sl, k) { sl.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      }
      var prev = box.querySelector('[data-h-slider-prev]');
      var next = box.querySelector('[data-h-slider-next]');
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-h-slider-dot'), 10)); }); });
      var t = null;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(paint, 60); }, { passive: true });
      paint();

      // Optional autoplay. It holds while the pointer, a finger or focus is on the
      // slider, stops for good once the shopper uses it, and has its own button.
      var secs = parseInt(box.getAttribute('data-h-slider-auto'), 10);
      if (!secs || slides.length < 2 || reduceMotion.matches) return;
      var playBtn = box.querySelector('[data-h-slider-play]');
      var timer = null, held = false, stopped = false;
      // :hover is asked at each tick: mouseenter alone missed a pointer already resting on it.
      function tick() { if (!held && !box.matches(':hover') && !stopped && !document.hidden) go(index() + 1); }
      function start() { clearInterval(timer); timer = setInterval(tick, secs * 1000); }
      function setPlaying(on) {
        stopped = !on;
        if (on) start(); else clearInterval(timer);
        if (playBtn) {
          playBtn.setAttribute('aria-pressed', on ? 'false' : 'true');
          playBtn.setAttribute('aria-label', playBtn.getAttribute(on ? 'data-pause' : 'data-play'));
          playBtn.classList.toggle('is-paused', !on);
        }
      }
      if (playBtn) {
        playBtn.hidden = false;
        playBtn.addEventListener('click', function () { setPlaying(stopped); });
      }
      box.addEventListener('mouseenter', function () { held = true; });
      box.addEventListener('mouseleave', function () { held = false; });
      box.addEventListener('focusin', function () { held = true; });
      box.addEventListener('focusout', function (e) { if (!box.contains(e.relatedTarget)) held = false; });
      box.addEventListener('touchstart', function () { setPlaying(false); }, { passive: true });
      [prev, next].forEach(function (b) { if (b) b.addEventListener('click', function () { setPlaying(false); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { setPlaying(false); }); });
      setPlaying(true);
    });
  }

  /* ---------- routine builder (homepage) ---------- */
  // Unticking a step takes it out of the set: its two hidden inputs are disabled
  // so the add posts only what is ticked, and the summary follows. The saving is
  // only drawn when the section carries a set discount the shop really runs.
  function routineBuilder() {
    document.querySelectorAll('[data-h-routine]').forEach(function (box) {
      // Its own flag: the bundle marks the same box hReady when it loads its
      // products, and sharing that flag left the total at the first item.
      if (box.dataset.hRoutineOn) return;
      box.dataset.hRoutineOn = '1';
      var pct = parseFloat(box.getAttribute('data-pct')) || 0;
      var steps = Array.prototype.slice.call(box.querySelectorAll('.h-rstep'));
      var lines = box.querySelectorAll('[data-h-routine-line]');
      var totalEl = box.querySelector('[data-h-routine-total]');
      var wasEl = box.querySelector('[data-h-routine-was]');
      var saveEl = box.querySelector('[data-h-routine-save]');
      var submit = box.querySelector('[data-h-routine-submit]');
      function paint() {
        var total = 0, ticked = 0;
        steps.forEach(function (st, i) {
          var cb = st.querySelector('[data-h-routine-step]');
          var on = cb && cb.checked && !cb.disabled;
          st.classList.toggle('is-off', !on);
          st.querySelectorAll('[data-h-routine-item]').forEach(function (inp) { inp.disabled = !on; });
          if (lines[i]) lines[i].hidden = !on;
          if (on) { total += parseInt(cb.getAttribute('data-price'), 10) || 0; ticked++; }
        });
        var cut = pct > 0 ? Math.floor(total * pct / 100) : 0;
        if (totalEl) totalEl.innerHTML = formatMoney(total - cut);
        if (wasEl) { wasEl.innerHTML = formatMoney(total); wasEl.hidden = cut === 0; }
        if (saveEl) {
          saveEl.hidden = cut === 0;
          saveEl.innerHTML = (saveEl.getAttribute('data-template') || '__V__').replace('__V__', formatMoney(cut));
        }
        if (submit) submit.disabled = ticked === 0;
      }
      box.addEventListener('change', function (e) { if (e.target.matches('[data-h-routine-step]')) paint(); });
      paint();
    });
  }

  /* ---------- buy again: subscription switch and how-often chips ---------- */
  // The switch posts the card's selling plan with the add; the chips pick which
  // plan by its name, for every card that has a plan of that name.
  function buyAgain() {
    document.querySelectorAll('[data-h-again]').forEach(function (band) {
      if (band.dataset.hReady) return;
      band.dataset.hReady = '1';
      function planFor(input, name) {
        var pairs = (input.getAttribute('data-plans') || '').split('|');
        for (var i = 0; i < pairs.length; i++) {
          var kv = pairs[i].split('=');
          if (kv[0] === name && kv[1]) return kv[1];
        }
        return null;
      }
      band.addEventListener('change', function (e) {
        if (!e.target.matches('[data-h-again-sub]')) return;
        var plan = e.target.closest('form').querySelector('[data-h-again-plan]');
        if (plan) plan.disabled = !e.target.checked;
      });
      band.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-h-again-freq]');
        if (!chip) return;
        var name = chip.getAttribute('data-h-again-freq');
        band.querySelectorAll('[data-h-again-freq]').forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
        band.querySelectorAll('[data-h-again-plan]').forEach(function (inp) {
          var id = planFor(inp, name);
          if (id) inp.value = id;
        });
      });
    });
  }

  /* ---------- app banner ---------- */
  // Closing it is remembered per visitor (the key changes when the merchant wants
  // it seen again). On a phone the one button picks the store for the device.
  function appBanner() {
    document.querySelectorAll('[data-h-appbar]').forEach(function (bar) {
      if (bar.dataset.hReady) return;
      bar.dataset.hReady = '1';
      var key = 'halsa:appbar:' + bar.getAttribute('data-h-appbar');
      try { if (localStorage.getItem(key)) { bar.hidden = true; return; } } catch (e) {}
      bar.querySelectorAll('[data-h-appbar-close]').forEach(function (b) {
        b.addEventListener('click', function () {
          bar.hidden = true;
          try { localStorage.setItem(key, '1'); } catch (e) {}
        });
      });
      var get = bar.querySelector('[data-h-appbar-get]');
      if (get) {
        var android = /android/i.test(navigator.userAgent);
        var url = android ? get.getAttribute('data-android') : get.getAttribute('data-ios');
        if (url) get.href = url;
      }
    });
  }

  /* ---------- address forms: province list follows the country ---------- */
  function addressSelectors() {
    if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;
    document.querySelectorAll('[data-h-country]').forEach(function (sel) {
      if (sel.dataset.hReady) return;
      sel.dataset.hReady = '1';
      var p = sel.getAttribute('data-h-country');
      new window.Shopify.CountryProvinceSelector(sel.id, 'a-' + p + '-province', { hideElement: 'a-' + p + '-province-wrap' });
    });
  }

  /* ---------- phone prefix (register) ---------- */
  // The +355 beside the field is only a label; a local number such as 069… went
  // to Shopify without its country code. Add it on the way out unless the number
  // already carries one.
  function phonePrefix() {
    document.addEventListener('submit', function (e) {
      var field = e.target.querySelector && e.target.querySelector('[data-h-phone-prefix]');
      if (!field) return;
      var raw = field.value.replace(/[\s().-]/g, '');
      if (!raw || raw.charAt(0) === '+') return;
      if (raw.slice(0, 2) === '00') { field.value = '+' + raw.slice(2); return; }
      var prefix = field.getAttribute('data-h-phone-prefix').replace(/\s/g, '');
      field.value = prefix + raw.replace(/^0+/, '');
    }, true);
  }

  /* ---------- homepage sections built on scroll ---------- */
  // Each placeholder fetches its section (Section Rendering API) when it comes
  // within about two screens, swaps it in, and wires it like the rest of the page.
  function lazySections() {
    var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-h-lazy-section]:not([data-h-loading])'));
    if (!boxes.length) return;
    var load = function (box) {
      if (box.hasAttribute('data-h-loading')) return;
      box.setAttribute('data-h-loading', '');
      var id = box.getAttribute('data-h-lazy-section');
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', id);
      fetch(url.toString()).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
        // A placeholder coming back means the store built it lazily again: stop here.
        if (!fresh || fresh.querySelector('[data-h-lazy-section]')) { box.removeAttribute('aria-busy'); return; }
        var host = box.parentNode;
        host.innerHTML = fresh.innerHTML;
        init();
      }).catch(function () { box.removeAttribute('data-h-loading'); });
    };
    if (!('IntersectionObserver' in window)) { boxes.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
    }, { rootMargin: '1600px 0px' });
    boxes.forEach(function (b) { io.observe(b); });
  }

  /* ---------- "Oferta e ditës": a new day's deals without a reload ---------- */
  // The section picks the day's products on the server and says when that day
  // ends (data-h-dod-until, seconds). A page loaded from an older copy, or a tab
  // still open at the reset, fetches the section again and swaps it in.
  function dealRotate() {
    document.querySelectorAll('[data-h-dod-until]').forEach(function (el) {
      if (el._hDod) return;
      el._hDod = true;
      var until = parseInt(el.getAttribute('data-h-dod-until'), 10) * 1000;
      if (isNaN(until)) return;
      var id = el.getAttribute('data-h-dod');
      var refresh = function () {
        var url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.set('section_id', id);
        url.searchParams.set('dod', Math.floor(Date.now() / 60000));
        fetch(url.toString()).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-h-dod-until]');
          var host = el.closest('.shopify-section') || el.parentNode;
          if (!fresh || !host || fresh.getAttribute('data-h-dod-until') === el.getAttribute('data-h-dod-until')) return;
          host.innerHTML = (tmp.querySelector('#shopify-section-' + id) || tmp).innerHTML;
          init();
        }).catch(function () {});
      };
      var wait = until - Date.now();
      if (wait <= 0) refresh();
      else if (wait < 2147483647) setTimeout(refresh, wait + 3000);
    });
  }

  /* ---------- tab shelves: later tabs load when opened ---------- */
  // The page carries only the first tab's products; another tab's cards come from
  // its collection's cards view the first time it is shown, or on hover first.
  function lazyTabs() {
    var load = function (grid) {
      if (!grid || grid.dataset.hLoaded) return;
      grid.dataset.hLoaded = '1';
      var limit = parseInt(grid.getAttribute('data-limit'), 10) || 4;
      fetch(grid.getAttribute('data-h-tab-lazy')).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = Array.prototype.slice.call(tmp.querySelectorAll('.h-pcard')).slice(0, limit);
        if (grid.hasAttribute('data-no-add')) cards.forEach(function (c) { var a = c.querySelector('.h-pcard__actions'); if (a) a.parentNode.removeChild(a); });
        grid.innerHTML = '';
        cards.forEach(function (c) { grid.appendChild(c); });
        if (!cards.length) grid.hidden = true;
      }).catch(function () { delete grid.dataset.hLoaded; });
    };
    document.querySelectorAll('[data-h-tab-lazy]').forEach(function (grid) {
      if (grid.dataset.hReady) return;
      grid.dataset.hReady = '1';
      var panel = grid.closest('[role="tabpanel"]');
      if (!panel) { load(grid); return; }
      if (!panel.hidden) { load(grid); return; }
      new MutationObserver(function (m, obs) { if (!panel.hidden) { load(grid); obs.disconnect(); } }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      var tab = document.querySelector('[role="tab"][data-panel="' + panel.id + '"]');
      if (tab) {
        tab.addEventListener('pointerenter', function () { load(grid); });
        tab.addEventListener('focus', function () { load(grid); });
      }
    });
  }

  /* ---------- apps and the cart ---------- */
  // Cart, upsell and bundle apps change the cart on their own. Three ways they
  // and the theme stay in step, without a page reload:
  //  · an app that calls /cart/add, change, update or clear itself is noticed
  //    (Resource Timing) and the drawer, cart page and header refresh. The
  //    theme's own requests carry ?h=theme so they are not counted twice;
  //  · an app can ask: dispatch cart:refresh (or cart:build, theme:cart:refresh)
  //    to refresh, cart:open (or theme:cart:open, cart-drawer:open) to open the
  //    drawer;
  //  · after every change the theme makes, it dispatches cart:updated with the
  //    cart in event.detail.cart.
  function cartAppEvents() {
    if (document.documentElement.dataset.hCartEvents) return;
    document.documentElement.dataset.hCartEvents = '1';
    var pending = null;
    function refresh() {
      clearTimeout(pending);
      pending = setTimeout(function () { if (cartSectionIds().length) refreshCart(); else syncHeader(); }, 250);
    }
    ['cart:refresh', 'cart:build', 'theme:cart:refresh'].forEach(function (name) { document.addEventListener(name, refresh); });
    ['cart:open', 'theme:cart:open', 'cart-drawer:open'].forEach(function (name) {
      document.addEventListener(name, function () {
        refresh();
        if (!openDrawer('h-cart-drawer')) window.location.href = '/cart';
      });
    });
    if ('PerformanceObserver' in window) {
      var cartCall = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (e) {
            if ((e.initiatorType === 'fetch' || e.initiatorType === 'xmlhttprequest') && cartCall.test(e.name) && e.name.indexOf('h=theme') < 0) refresh();
          });
        }).observe({ type: 'resource', buffered: false });
      } catch (err) {}
    }
  }

  /* ---------- dialogs opened by a button (size chart) ---------- */
  function dialogs() {
    if (document.documentElement.dataset.hDialogsReady) return;
    document.documentElement.dataset.hDialogsReady = '1';
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-h-dialog-open]');
      if (opener) {
        var d = document.getElementById(opener.getAttribute('data-h-dialog-open'));
        if (d && typeof d.showModal === 'function') { e.preventDefault(); d.showModal(); }
        return;
      }
      var dlg = e.target.closest('[data-h-dialog]');
      if (dlg && (e.target === dlg || e.target.closest('[data-h-dialog-close]'))) dlg.close();
    });
  }

  /* ---------- Judge.me in the design (product page) ---------- */
  // Judge.me renders its widget after the page; once it is there our score moves
  // into its left column (assets/judgeme.css lays it out) and our "Shkruaj një
  // vlerësim" button opens Judge.me's own form.
  function reviewsSkin() {
    document.querySelectorAll('[data-h-reviews]').forEach(function (sec) {
      if (sec.dataset.hReady) return;
      sec.dataset.hReady = '1';
      var btn = sec.querySelector('[data-h-review-write]');
      function wire() {
        var widg = sec.querySelector('.jdgm-rev-widg');
        if (!widg) return false;
        var score = sec.querySelector('[data-h-reviews-score]');
        if (score && score.parentNode !== widg) widg.insertBefore(score, widg.firstChild);
        var link = widg.querySelector('.jdgm-write-rev-link');
        if (btn && link) {
          btn.hidden = false;
          if (!btn.dataset.hWired) {
            btn.dataset.hWired = '1';
            btn.addEventListener('click', function () {
              var l = sec.querySelector('.jdgm-write-rev-link');
              if (l) l.click();
              var form = sec.querySelector('.jdgm-form-wrapper');
              if (form && form.scrollIntoView) form.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
            });
          }
        }
        return true;
      }
      // Without Judge.me's core script (its app embed off: window.jdgmSettings is
      // missing) the widget renders but its page buttons and dates do nothing.
      // Then the pages come from Judge.me's public review feed, the one its own
      // widget reads, and the dates are written from each review's datetime.
      function judgeOff() { return typeof window.jdgmSettings === 'undefined'; }
      function fillDates(root) {
        if (!judgeOff()) return;
        // The month names are the theme's own (general.months), as on every other date.
        var months = (sec.getAttribute('data-months') || '').split(',');
        root.querySelectorAll('.jdgm-rev__timestamp').forEach(function (t) {
          if (t.textContent.trim()) return;
          var d = new Date(t.getAttribute('datetime') || '');
          if (isNaN(d)) return;
          var m = months.length === 12 ? months[d.getMonth()].trim() : String(d.getMonth() + 1);
          t.textContent = d.getDate() + ' ' + m + ' ' + d.getFullYear();
          t.classList.remove('jdgm-spinner');
        });
      }
      if (!sec.dataset.hPager) {
        sec.dataset.hPager = '1';
        sec.addEventListener('click', function (e) {
          var pg = e.target.closest('.jdgm-paginate__page');
          if (!pg || !judgeOff() || !window.fetch) return;
          var widget = sec.querySelector('.jdgm-widget[data-product-id]');
          var shopDomain = window.Shopify && window.Shopify.shop;
          var page = parseInt(pg.getAttribute('data-page'), 10);
          if (!widget || !shopDomain || !page) return;
          e.preventDefault();
          var list = sec.querySelector('.jdgm-rev-widg__reviews');
          var per = Math.max(1, (sec.dataset.hPerPage = sec.dataset.hPerPage || (list ? list.querySelectorAll('.jdgm-rev').length : 5)) | 0);
          var url = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shopDomain) +
            '&shop_domain=' + encodeURIComponent(shopDomain) + '&platform=shopify&page=' + page +
            '&per_page=' + per + '&product_id=' + encodeURIComponent(widget.getAttribute('data-product-id'));
          sec.classList.add('is-loading');
          fetch(url).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (data) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data.html || '';
            var freshList = tmp.querySelector('.jdgm-rev-widg__reviews');
            var freshPager = tmp.querySelector('.jdgm-paginate');
            var pager = sec.querySelector('.jdgm-paginate');
            if (freshList && list) list.parentNode.replaceChild(freshList, list);
            if (freshPager && pager) pager.parentNode.replaceChild(freshPager, pager);
            fillDates(sec);
            var top = sec.querySelector('.jdgm-rev-widg__reviews');
            if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          }).catch(function () {}).then(function () { sec.classList.remove('is-loading'); });
        });
      }
      if (wire()) { fillDates(sec); return; }
      if (!('MutationObserver' in window)) return;
      var mo = new MutationObserver(function () { if (wire()) { fillDates(sec); mo.disconnect(); } });
      mo.observe(sec, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    });
  }

  /* ---------- brand index search (design 2026) ---------- */
  // Filters the A–Z list as you type (ë and ç match e and c); a letter row with
  // nothing left hides, and an empty search shows everything again.
  function brandIndex() {
    var fold = function (t) {
      return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    document.querySelectorAll('[data-h-bindex]').forEach(function (head) {
      var input = head.querySelector('[data-h-bindex-search]');
      if (!input || head.dataset.hReady) return;
      head.dataset.hReady = '1';
      var list = document.querySelector('.h-bindex__list');
      if (!list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('[data-h-bindex-item]'));
      var none = list.querySelector('[data-h-bindex-none]');
      input.addEventListener('input', function () {
        var q = fold(input.value.trim());
        var shown = 0;
        items.forEach(function (li) {
          var hit = !q || fold(li.textContent).indexOf(q) > -1;
          li.hidden = !hit;
          if (hit) shown++;
        });
        list.querySelectorAll('[data-h-bindex-row]').forEach(function (row) {
          row.hidden = !row.querySelector('[data-h-bindex-item]:not([hidden])');
        });
        if (none) none.hidden = shown > 0;
      });
    });
  }

  /* ---------- article: contents and share (design 2026) ---------- */
  // The contents list is built from the article's own <h2>s, so it never lists
  // a heading the text does not have; the one being read is marked.
  function articleToc() {
    var nav = document.querySelector('[data-h-toc]');
    var src = document.querySelector('[data-h-toc-source]');
    if (nav && src && !nav.dataset.hReady) {
      nav.dataset.hReady = '1';
      // The article's own sections: its h2s, or its h3s when it has fewer than two h2s.
      var heads = Array.prototype.slice.call(src.querySelectorAll('h2'));
      if (heads.length < 2) heads = Array.prototype.slice.call(src.querySelectorAll('h3'));
      if (heads.length >= 2) {
        var list = nav.querySelector('[data-h-toc-list]');
        var links = heads.map(function (h, i) {
          if (!h.id) h.id = 'h-sec-' + (i + 1);
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent.trim();
          li.appendChild(a);
          list.appendChild(li);
          return a;
        });
        nav.hidden = false;
        var n = nav.querySelector('[data-h-toc-n]');
        if (n) n.textContent = (n.getAttribute('data-template') || '(__N__)').replace('__N__', heads.length);
        // Folded on phones, always open on desktop.
        var mq = window.matchMedia('(max-width: 900px)');
        var setOpen = function () { nav.open = !mq.matches; };
        setOpen();
        if (mq.addEventListener) mq.addEventListener('change', setOpen);
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting) return;
              links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id); });
            });
          }, { rootMargin: '0px 0px -70% 0px' });
          heads.forEach(function (h) { io.observe(h); });
        }
      }
    }
    document.querySelectorAll('[data-h-copy-link]').forEach(function (b) {
      if (b.dataset.hReady) return;
      b.dataset.hReady = '1';
      if (!navigator.clipboard) { b.hidden = true; return; }
      b.addEventListener('click', function () {
        navigator.clipboard.writeText(b.getAttribute('data-h-copy-link')).then(function () {
          toast(b.getAttribute('data-done') || 'OK');
        });
      });
    });
  }

  /* ---------- newsletter popup (design 2026) ---------- */
  // Once per visitor: after the delay, or when the pointer leaves for the tabs.
  // Closing it, declining or signing up keeps it closed (localStorage); after a
  // sign-up the page comes back with the thank-you state, shown once.
  function newsletterPopup() {
    var dlg = document.querySelector('[data-h-npop]');
    if (!dlg || dlg.dataset.hReady || typeof dlg.showModal !== 'function') return;
    dlg.dataset.hReady = '1';
    var key = 'h-' + dlg.getAttribute('data-key');
    var seen = function () { try { return !!localStorage.getItem(key); } catch (e) { return false; } };
    var remember = function () { try { localStorage.setItem(key, '1'); } catch (e) {} };
    var busy = function () { return document.querySelector('dialog[open]') || document.querySelector('[data-h-drawer].is-open'); };
    var open = function () {
      if (dlg.open || seen() || busy()) return;
      remember();
      dlg.showModal();
    };
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-h-npop-close]')) dlg.close();
    });
    dlg.addEventListener('close', remember);
    var form = dlg.closest('form');
    if (form) form.addEventListener('submit', remember);
    if (dlg.hasAttribute('data-done')) { dlg.showModal(); remember(); return; }
    if (seen()) return;
    var delay = (parseInt(dlg.getAttribute('data-delay'), 10) || 12) * 1000;
    setTimeout(open, delay);
    if (dlg.getAttribute('data-exit') === 'true' && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) open();
      });
    }
  }

  /* ---------- store locator (design 2026) ---------- */
  // Hapur / Mbyllur from each store's hours in the shop's time zone (the offset
  // the page was rendered with), the map only on request, and a filter.
  function storeLocator() {
    document.querySelectorAll('[data-h-stores]').forEach(function (root) {
      if (root.dataset.hReady) return;
      root.dataset.hReady = '1';
      var tz = /([+-])(\d\d)(\d\d)/.exec(root.getAttribute('data-tz') || '+0000');
      var offset = tz ? (tz[1] === '-' ? -1 : 1) * (parseInt(tz[2], 10) * 60 + parseInt(tz[3], 10)) : 0;
      var mins = function (hm) { var m = /^(\d{1,2}):(\d\d)$/.exec((hm || '').trim()); return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null; };
      var stores = Array.prototype.slice.call(root.querySelectorAll('[data-h-store]'));
      function paint() {
        var d = new Date();
        var now = ((d.getUTCHours() * 60 + d.getUTCMinutes() + offset) % 1440 + 1440) % 1440;
        stores.forEach(function (b) {
          var el = b.querySelector('[data-h-store-status]');
          var o = mins(b.getAttribute('data-open')), c = mins(b.getAttribute('data-close'));
          if (!el || o === null || c === null) return;
          var open = c > o ? (now >= o && now < c) : (now >= o || now < c);
          el.textContent = root.getAttribute(open ? 'data-open-label' : 'data-closed-label');
          el.classList.toggle('is-open', open);
          el.hidden = false;
        });
      }
      paint();
      setInterval(paint, 60000);
      var map = root.querySelector('[data-h-stores-map]');
      var frame = null;
      function show(b) {
        if (!frame || !b) return;
        frame.src = b.getAttribute('data-map');
        var name = b.querySelector('b');
        frame.title = name ? name.textContent : '';
      }
      stores.forEach(function (b) {
        b.addEventListener('click', function () {
          stores.forEach(function (o) { o.classList.toggle('is-active', o === b); o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          show(b);
        });
      });
      var load = root.querySelector('[data-h-stores-load]');
      if (load) load.addEventListener('click', function () {
        frame = document.createElement('iframe');
        frame.loading = 'lazy';
        map.innerHTML = '';
        map.appendChild(frame);
        show(root.querySelector('[data-h-store].is-active') || stores[0]);
      });
      var input = root.querySelector('[data-h-stores-search]');
      var none = root.querySelector('[data-h-stores-none]');
      if (input) input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        stores.forEach(function (b) {
          var hit = !q || b.textContent.toLowerCase().indexOf(q) > -1;
          b.parentElement.hidden = !hit;
          if (hit) shown++;
        });
        if (none) none.hidden = shown > 0;
      });
    });
  }

  /* ---------- FAQ page search (design 2026) ---------- */
  // Filters as you type; ë and ç match e and c, so "kthim" finds "Kthimet" and
  // "pagese" finds "pagesë". Matching answers open; emptied search restores all.
  function faqSearch() {
    var fold = function (t) {
      return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ë/g, 'e').replace(/ç/g, 'c');
    };
    document.querySelectorAll('[data-h-faq]').forEach(function (root) {
      var input = root.querySelector('[data-h-faq-search]');
      if (!input || root.dataset.hReady) return;
      root.dataset.hReady = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-h-faq-item]'));
      var none = root.querySelector('[data-h-faq-none]');
      input.addEventListener('input', function () {
        var q = fold(input.value.trim());
        var shown = 0;
        items.forEach(function (d) {
          var hit = !q || fold(d.textContent).indexOf(q) > -1;
          d.hidden = !hit;
          if (q) d.open = hit;
          if (hit) shown++;
        });
        root.querySelectorAll('[data-h-faq-group]').forEach(function (g) {
          g.hidden = !g.querySelector('[data-h-faq-item]:not([hidden])');
        });
        if (none) none.hidden = shown > 0;
      });
      root.querySelectorAll('.h-faqp__topic').forEach(function (a) {
        a.addEventListener('click', function () {
          root.querySelectorAll('.h-faqp__topic').forEach(function (o) { o.classList.toggle('is-active', o === a); });
        });
      });
    });
  }

  /* ---------- buy together (design 2026, product page) ---------- */
  // The page renders this product; the complementary ones arrive from the
  // recommendations endpoint as list items. They join the list, take the next
  // items[n] slots, and the routine maths does the totals. No items, no section.
  function productBundle() {
    document.querySelectorAll('[data-h-bundle]').forEach(function (box) {
      var url = box.getAttribute('data-url');
      if (box.dataset.hReady || !url || !window.fetch) return;
      box.dataset.hReady = '1';
      // Complementary products are the ones set in Search & Discovery; a product
      // with none falls back to Shopify's own related picks.
      var get = function (u) { return fetch(u).then(function (r) { return r.text(); }); };
      get(url).then(function (html) {
        if (html.indexOf('data-h-bundle-rec') > -1 || url.indexOf('intent=complementary') < 0) return html;
        return get(url.replace('intent=complementary', 'intent=related'));
      }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var recs = tmp.querySelectorAll('[data-h-bundle-rec]');
        if (!recs.length) return;
        var list = box.querySelector('[data-h-bundle-items]');
        Array.prototype.forEach.call(recs, function (li, i) {
          li.querySelectorAll('input[name]').forEach(function (inp) {
            inp.name = inp.name.replace('__I__', String(i + 1));
          });
          list.appendChild(li);
        });
        var count = function () {
          var n = box.querySelectorAll('[data-h-routine-step]:checked').length;
          box.querySelectorAll('[data-h-bundle-count]').forEach(function (el) { el.textContent = n; });
        };
        box.addEventListener('change', count);
        count();
        box.setAttribute('data-h-routine', '');
        box.hidden = false;
        routineBuilder();
      }).catch(function () {});
    });
  }

  /* ---------- "Krahaso gamën" on the product page ---------- */
  // sections/product-range names the range; the store's search returns that
  // brand's products as data (templates/search.range). Only the ones whose name
  // holds the range are kept, the product being viewed goes last and is marked,
  // and a row is drawn for each fact at least two of them share.
  function productRange() {
    document.querySelectorAll('[data-h-prange]').forEach(function (box) {
      if (box.dataset.hReady || !window.fetch) return;
      box.dataset.hReady = '1';
      var labels = {};
      var tpl = box.querySelector('[data-h-prange-labels]');
      if (tpl) Array.prototype.forEach.call(tpl.content.querySelectorAll('[data-k]'), function (el) { labels[el.getAttribute('data-k')] = el.textContent; });
      var vendor = (box.getAttribute('data-vendor') || '').toLowerCase();
      var range = (box.getAttribute('data-range') || '').toLowerCase();
      var current = box.getAttribute('data-current');
      fetch(box.getAttribute('data-h-prange')).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var seen = {};
        var items = Array.prototype.slice.call(tmp.querySelectorAll('[data-h-prange-item]')).filter(function (el) {
          var id = el.getAttribute('data-id');
          if (seen[id]) return false;
          seen[id] = true;
          return (el.getAttribute('data-vendor') || '').toLowerCase() === vendor &&
            (el.getAttribute('data-title') || '').toLowerCase().indexOf(range) > -1;
        });
        var mine = items.filter(function (el) { return el.getAttribute('data-id') === current; });
        items = items.filter(function (el) { return el.getAttribute('data-id') !== current; }).slice(0, 5).concat(mine);
        if (items.length < 3 || !mine.length) return;

        var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
        var facts = items.map(function (el) {
          var f = {};
          el.querySelectorAll('[data-fact]').forEach(function (i) { f[i.getAttribute('data-fact')] = i.textContent.trim(); });
          return f;
        });
        var keys = [];
        facts.forEach(function (f) { Object.keys(f).forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); }); });
        keys = keys.filter(function (k) { return facts.filter(function (f) { return f[k]; }).length >= 2; });
        var cell = function (v) {
          var low = (v || '').toLowerCase();
          if (low === 'po' || low === 'yes' || low === '✓') return '<span class="h-prange__yes" aria-label="' + esc(v) + '">&#10003;</span>';
          if (!v || low === 'jo' || low === 'no' || low === '-' || low === '—') return '<span class="h-prange__no" aria-label="' + esc(v || '—') + '">&ndash;</span>';
          return esc(v);
        };
        var cls = function (i) { return items[i].getAttribute('data-id') === current ? ' class="is-this"' : ''; };

        var head = '<thead><tr><td></td>' + items.map(function (el, i) {
          var img = el.querySelector('img');
          var was = el.getAttribute('data-was');
          return '<th scope="col"' + cls(i) + '>' +
            (el.getAttribute('data-id') === current ? '<span class="h-prange__tag">' + esc(labels.current) + '</span>' : '') +
            '<a class="h-prange__pic" href="' + el.getAttribute('data-url') + '">' + (img ? img.outerHTML : '') + '</a>' +
            '<a class="h-prange__n" href="' + el.getAttribute('data-url') + '">' + esc(el.getAttribute('data-name')) + '</a>' +
            '<span class="h-prange__p' + (was ? ' is-sale' : '') + '"><b>' + esc(el.getAttribute('data-price')) + '</b>' + (was ? '<s>' + esc(was) + '</s>' : '') + '</span></th>';
        }).join('') + '</tr></thead>';
        var rows = keys.map(function (k) {
          return '<tr><th scope="row">' + esc(k) + '</th>' + facts.map(function (f, i) { return '<td' + cls(i) + '>' + cell(f[k]) + '</td>'; }).join('') + '</tr>';
        });
        var sizes = items.map(function (el) { return el.getAttribute('data-size'); });
        if (sizes.filter(Boolean).length >= 2 && keys.length < 2) {
          rows.push('<tr><th scope="row">' + esc(labels.size) + '</th>' + sizes.map(function (v, i) { return '<td' + cls(i) + '>' + cell(v) + '</td>'; }).join('') + '</tr>');
        }
        var ratings = items.map(function (el) { return el.getAttribute('data-rating'); });
        if (ratings.filter(Boolean).length >= 2) {
          rows.push('<tr><th scope="row">' + esc(labels.rating) + '</th>' + ratings.map(function (v, i) { return '<td' + cls(i) + '>' + (v ? '<span class="h-prange__star">&#9733;</span> ' + esc(v) : cell('')) + '</td>'; }).join('') + '</tr>');
        }
        rows.push('<tr class="h-prange__acts"><td></td>' + items.map(function (el, i) {
          return el.getAttribute('data-id') === current
            ? '<td class="is-this"><a class="h-btn h-btn--quiet h-prange__btn" href="#h-product-form">' + esc(labels.buy) + ' &uarr;</a></td>'
            : '<td><a class="h-btn h-btn--outline h-prange__btn" href="' + el.getAttribute('data-url') + '">' + esc(labels.view) + '</a></td>';
        }).join('') + '</tr>');
        box.querySelector('[data-h-prange-table]').innerHTML = head + '<tbody>' + rows.join('') + '</tbody>';
        box.hidden = false;
      }).catch(function () {});
    });
  }

  /* ---------- "U shtua në shportë" notice (design 2026) ---------- */
  // A card under the cart icon on desktop that lets go after a few seconds unless
  // the pointer or focus is on it; a sheet from the bottom on phones that stays
  // until it is closed. Its markup is a cart section, re-rendered with every add.
  var noticeTimer = null, noticeReturn = null;
  var phone = function () { return window.matchMedia('(max-width: 600px)').matches; };
  function replaceNotice(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#h-cart-notice');
    var live = document.getElementById('h-cart-notice');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  }
  function closeNotice() {
    var box = document.getElementById('h-cart-notice');
    clearTimeout(noticeTimer);
    if (!box || box.hidden) return;
    box.hidden = true;
    box.classList.remove('is-sheet');
    document.documentElement.classList.remove('h-noscroll');
    if (noticeReturn && document.contains(noticeReturn)) noticeReturn.focus();
    noticeReturn = null;
  }
  function openNotice(added) {
    var box = document.getElementById('h-cart-notice');
    if (!box) return;
    var n = added > 1 ? added : 1;
    box.querySelectorAll('[data-h-cnotice-line]').forEach(function (line, i) { line.hidden = i >= n; });
    var title = box.querySelector('[data-h-cnotice-title]');
    if (title && n > 1 && title.getAttribute('data-many')) title.textContent = title.getAttribute('data-many').replace('__N__', n);
    var card = box.querySelector('.h-cnotice__card');
    noticeReturn = document.activeElement;
    var sheet = phone();
    box.classList.toggle('is-sheet', sheet);
    if (!sheet) {
      var icon = document.querySelector('.h-header .h-cart');
      var r = icon && icon.getBoundingClientRect();
      box.style.setProperty('--h-cnotice-top', ((r && r.bottom > 0 ? r.bottom : 70) + 10) + 'px');
    }
    box.hidden = false;
    if (sheet) {
      document.documentElement.classList.add('h-noscroll');
      if (card) card.focus();
      var recs = box.querySelector('[data-h-cnotice-recs]');
      if (recs && recs.getAttribute('data-url') && !recs.dataset.hReady) {
        recs.dataset.hReady = '1';
        fetch(recs.getAttribute('data-url')).then(function (res) { return res.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var body = tmp.querySelector('[data-h-cnotice-recs-body]');
          if (body) recs.appendChild(body);
        }).catch(function () {});
      }
    } else {
      armNotice(box);
    }
  }
  function armNotice(box) {
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      if (box.matches(':hover') || box.contains(document.activeElement)) { armNotice(box); return; }
      closeNotice();
    }, 6000);
  }
  function cartNotice() {
    if (!document.getElementById('h-cart-notice') || document.documentElement.dataset.hNoticeReady) return;
    document.documentElement.dataset.hNoticeReady = '1';
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-h-cnotice-close]')) { e.preventDefault(); closeNotice(); }
    });
    document.addEventListener('keydown', function (e) {
      var box = document.getElementById('h-cart-notice');
      if (e.key === 'Escape' && box && !box.hidden) closeNotice();
    });
  }

  /* ---------- quick view (design 2026, desktop) ---------- */
  // The card's "Shiko shpejt" fetches sections/quick-view for that product into a
  // modal <dialog>: focus is held inside it, Esc closes it and focus returns to
  // the button. If the fetch fails the button simply goes to the product page.
  // Loaded ahead: hovering a card for a moment, or focusing its button, starts the
  // request, so the click opens the window already filled. Kept per product URL.
  var qvCache = {};
  function qvLoad(url) {
    if (!qvCache[url]) {
      qvCache[url] = fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view')
        .then(function (r) { if (!r.ok) throw r; return r.text(); })
        .catch(function (err) { delete qvCache[url]; throw err; });
    }
    return qvCache[url];
  }
  function quickView() {
    if (document.documentElement.dataset.hQvReady) return;
    document.documentElement.dataset.hQvReady = '1';
    var hoverT = null;
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var card = e.target.closest && e.target.closest('.h-pcard');
      var btn = card && card.querySelector('[data-h-quick]');
      if (!btn || card.contains(e.relatedTarget)) return;
      clearTimeout(hoverT);
      hoverT = setTimeout(function () { qvLoad(btn.getAttribute('data-h-quick')).catch(function () {}); }, 150);
    });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('.h-pcard');
      if (card && !card.contains(e.relatedTarget)) clearTimeout(hoverT);
    });
    document.addEventListener('focusin', function (e) {
      var btn = e.target.closest && e.target.closest('[data-h-quick]');
      if (btn) qvLoad(btn.getAttribute('data-h-quick')).catch(function () {});
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-h-quick]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-h-quick');
      if (!window.fetch || typeof HTMLDialogElement === 'undefined') { window.location.href = url; return; }
      btn.setAttribute('aria-busy', 'true');
      qvLoad(url)
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var root = tmp.querySelector('[data-h-qv-root]');
          if (!root) throw new Error('no quick view');
          var dlg = document.getElementById('h-qv-dialog');
          if (!dlg) {
            dlg = document.createElement('dialog');
            dlg.id = 'h-qv-dialog';
            dlg.className = 'h-qvdialog';
            dlg.setAttribute('aria-labelledby', 'h-qv-title');
            dlg.addEventListener('click', function (ev) {
              if (ev.target === dlg || ev.target.closest('[data-h-qv-close]')) dlg.close();
            });
            dlg.addEventListener('close', function () { document.documentElement.classList.remove('h-noscroll'); });
            document.body.appendChild(dlg);
          }
          dlg.innerHTML = '<button type="button" class="h-qvdialog__x" data-h-qv-close aria-label="' + t('close', 'Close') + '">&#10005;</button>';
          dlg.appendChild(root);
          wireQuickView(root);
          quantity();
          document.documentElement.classList.add('h-noscroll');
          dlg.showModal();
          var first = root.querySelector('.h-qv__title');
          if (first) { first.setAttribute('tabindex', '-1'); first.focus(); }
        })
        .catch(function () { window.location.href = url; })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  }
  function wireQuickView(root) {
    var main = root.querySelector('.h-qv__main img');
    root.querySelectorAll('[data-h-qv-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-src'); }
        root.querySelectorAll('[data-h-qv-thumb]').forEach(function (o) {
          o.classList.toggle('is-active', o === b);
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
      });
    });
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-h-qv-variants]').textContent); } catch (err) { data = []; }
    var pick = function (id) {
      var v = null;
      data.forEach(function (d) { if (String(d.id) === String(id)) v = d; });
      if (!v) return;
      // Prices arrive as the shop's money format, which can be HTML, from our own Liquid.
      var set = function (sel, text, show, html) {
        var el = root.querySelector(sel);
        if (!el) return;
        if (text != null) { if (html) el.innerHTML = text; else el.textContent = text; }
        if (show != null) el.hidden = !show;
      };
      root.querySelector('[data-h-qv-id]').value = v.id;
      set('[data-h-qv-price]', v.price, null, true);
      set('[data-h-qv-was]', v.was || '', !!v.was, true);
      set('[data-h-qv-unit]', v.unit || '', !!v.unit, true);
      set('[data-h-qv-optval]', v.title);
      var add = root.querySelector('[data-h-qv-add]');
      if (add) add.disabled = !v.available;
      set('[data-h-qv-addlabel]', v.available ? t('add_to_cart', 'Add to cart') : t('sold_out', 'Sold out'));
      var more = root.querySelector('.h-qv__more');
      if (more && v.url) more.href = v.url;
      if (main && v.image) { main.removeAttribute('srcset'); main.src = v.image; }
      var strip = root.querySelector('.h-qv__thumbs[data-variant-media]');
      if (strip && v.media_id) {
        var thumbs = Array.prototype.slice.call(strip.querySelectorAll('[data-h-qv-thumb]'));
        var keep = variantGroup(thumbs.map(function (b) { return b.getAttribute('data-media-id'); }), strip.getAttribute('data-variant-media').split(',').filter(Boolean), v.media_id);
        thumbs.forEach(function (b) {
          b.hidden = !!keep && keep.indexOf(b.getAttribute('data-media-id')) < 0;
          var on = String(b.getAttribute('data-media-id')) === String(v.media_id);
          b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
    };
    root.querySelectorAll('[data-h-qv-variant]').forEach(function (el) {
      el.addEventListener('change', function () { pick(el.value); });
    });
  }

  /* ---------- loyalty panel ---------- */
  // "Shiko pikët e mia" opens Smile.io's own panel when the app embed has put it
  // on the page; without it the link simply goes to the account.
  function loyaltyLinks() {
    if (document.documentElement.dataset.hLoyaltyReady) return;
    document.documentElement.dataset.hLoyaltyReady = '1';
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-h-loyalty-open]');
      if (!a) return;
      var ui = window.SmileUI;
      if (ui && typeof ui.openPanel === 'function') {
        e.preventDefault();
        ui.openPanel();
      }
    });
  }

  /* ---------- mega menu (design 2026, desktop) ---------- */
  // Hover opens after a short pause so sweeping across the row does not flash
  // panels; focus opens at once, Esc closes and hands focus back to the item.
  // Below the desktop nav breakpoint the row is hidden and none of this runs.
  function megaMenu() {
    var items = document.querySelectorAll('[data-h-mega]');
    if (!items.length) return;
    var scrim = document.querySelector('[data-h-mega-scrim]');
    var desk = window.matchMedia('(min-width: 1025px)');
    var current = null, openT = null, closeT = null;
    function place() {
      if (!scrim || !current) return;
      var nav = current.closest('.h-nav');
      scrim.style.top = (nav ? nav.getBoundingClientRect().bottom : 0) + 'px';
    }
    function close(item) {
      item = item || current;
      if (!item) return;
      var panel = item.querySelector('.h-mega');
      if (panel) panel.hidden = true;
      var a = item.querySelector(':scope > a');
      if (a) a.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      if (current === item) current = null;
      if (scrim && !current) scrim.hidden = true;
    }
    function open(item) {
      if (!desk.matches) return;
      clearTimeout(closeT);
      if (current && current !== item) close(current);
      current = item;
      item.querySelector('.h-mega').hidden = false;
      item.querySelector(':scope > a').setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
      if (scrim) { scrim.hidden = false; place(); }
    }
    items.forEach(function (item) {
      if (item.dataset.hReady) return;
      item.dataset.hReady = '1';
      item.addEventListener('mouseenter', function () {
        clearTimeout(openT); clearTimeout(closeT);
        openT = setTimeout(function () { open(item); }, current ? 0 : 120);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openT);
        closeT = setTimeout(function () { if (current === item) close(item); }, 180);
      });
      item.addEventListener('focusin', function () { open(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !current) return;
        var a = item.querySelector(':scope > a');
        close(item);
        // Focus back on the item without reopening its panel.
        item.dataset.hHold = '1';
        if (a) a.focus();
        setTimeout(function () { delete item.dataset.hHold; }, 0);
      });
    });
    items.forEach(function (item) {
      item.addEventListener('focusin', function () { if (item.dataset.hHold) close(item); });
    });
    if (scrim && !scrim.dataset.hReady) {
      scrim.dataset.hReady = '1';
      scrim.addEventListener('mouseenter', function () { if (current) close(current); });
      scrim.addEventListener('click', function () { if (current) close(current); });
      window.addEventListener('scroll', function () { if (current) place(); }, { passive: true });
      desk.addEventListener('change', function () { if (current) close(current); });
    }
  }

  /* ---------- footer columns (design 2026) ---------- */
  // Open in the markup so they read without JS; folded into accordions on phones.
  function footerColumns() {
    if (!window.matchMedia('(max-width: 600px)').matches) return;
    document.querySelectorAll('[data-h-fcol]').forEach(function (d) {
      if (d.dataset.hReady) return;
      d.dataset.hReady = '1';
      d.open = false;
    });
  }

  var wired = false;
  function init() {
    tickers(); countdowns(); tabs(); quantity(); gallery(); zoom(); reels(); menuExtras(); variants();
    facetToggle(); facets(); sortSelect(); facetExtras(); readMore(); applyView(); autoSubmit(); recommendations(); stickyHeader(); cartPage();
    stickyBuyBar(); cutoffCountdown(); carousels(); quantityTotal(); reveal(); addressSelectors(); recordViewed(); viewedShelf(); didYouMean(); promoSliders(); appBanner(); routineBuilder(); buyAgain(); footerColumns(); megaMenu(); cartNotice(); quickView(); productBundle(); productRange(); faqSearch(); storeLocator(); newsletterPopup(); articleToc(); brandIndex(); reviewsSkin(); dialogs(); cartAppEvents(); lazyTabs(); lazySections(); dealRotate(); loyaltyLinks();
    if (!wired) { wired = true; drawers(); ajaxAdd(); drawerQty(); predictive(); coupon(); phonePrefix(); facetDelegates(); optionLists(); }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
